import CoinIcon from '../components/CoinIcon';
import WalletIcon from '../components/WalletIcon';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import useIsMobile from '../hooks/useIsMobile';
import api from '../api';
import { FiPlus, FiSearch, FiUsers, FiMapPin, FiCalendar, FiLogOut, FiUpload, FiBell, FiCheckCircle, FiClock, FiMessageCircle, FiSettings, FiStar, FiSend, FiLock, FiMail, FiUser, FiAlertCircle, FiCheck, FiEdit, FiTrash2, FiMessageSquare, FiTruck, FiGift, FiCreditCard, FiArrowUpCircle, FiArrowDown, FiArrowUp, FiX, FiThumbsUp, FiArrowLeft, FiChevronRight, FiHelpCircle } from 'react-icons/fi';
import { playNotificationSound } from '../utils/notificationSound';
import { subscribeToPush, unsubscribeFromPush } from '../utils/pushNotifications';
import { HiOutlineBuildingStorefront } from 'react-icons/hi2';
import { IoTicketOutline } from 'react-icons/io5';
import GigiBot from '../components/GigiBot';
import LoadingScreen from '../components/LoadingScreen';
import ThemeToggle from '../components/ThemeToggle';
import ImageCropper from '../components/ImageCropper';

const EVENT_TYPES = ['Wedding','Lobola','Umembeso','Birthday','Kids Party','Graduation','Gender Reveal','Engagement','Memorial / Unveiling','Funeral','Matric Dance','Corporate Event','Custom Event'];

const EVENT_VENDOR_MAP = {
  Wedding: ['Catering','Photography','Videography','Decor & Flowers','Venue','Music & Entertainment','Makeup & Beauty','Transport'],
  Lobola: ['Catering','Photography','Decor & Flowers','Transport','Venue'],
  Umembeso: ['Catering','Photography','Decor & Flowers','Transport','Venue'],
  Birthday: ['Catering','Photography','Cake & Bakery','Music & Entertainment','Decor & Flowers','Venue'],
  'Kids Party': ['Catering','Photography','Cake & Bakery','Music & Entertainment','Decor & Flowers','Jumping Castles & Play'],
  Graduation: ['Catering','Photography','Music & Entertainment','Decor & Flowers'],
  'Gender Reveal': ['Catering','Photography','Decor & Flowers','Cake & Bakery'],
  Engagement: ['Catering','Photography','Decor & Flowers','Makeup & Beauty','Venue'],
  'Memorial / Unveiling': ['Catering','Photography','Decor & Flowers','Transport'],
  Funeral: ['Catering','Photography','Transport'],
  'Matric Dance': ['Catering','Photography','Makeup & Beauty','Transport','Music & Entertainment'],
  'Corporate Event': ['Catering','Photography','Videography','Venue','Transport','Music & Entertainment'],
  'Custom Event': ['Catering','Photography','Decor & Flowers','Music & Entertainment','Venue'],
};

const DEFAULT_BANNERS = {
  'Wedding': '/hero/wedding-default.jpg',
  'Lobola': '/hero/lobola-default.jpg',
  'Umembeso': '/hero/umembeso-default.jpg',
  'Birthday': '/hero/birthday-default.jpg',
  'Kids Party': '/hero/kids-party-default.jpg',
  'Graduation': '/hero/graduation-default.jpg',
  'Gender Reveal': '/hero/gender-reveal-default.jpg',
  'Engagement': '/hero/engagement-default.jpg',
  'Memorial / Unveiling': '/hero/memorial-default.jpg',
  'Funeral': '/hero/funeral-default.jpg',
  'Matric Dance': '/hero/matric-dance-default.jpg',
  'Corporate Event': '/hero/corporate-default.jpg',
};

function getDefaultBanner(type) {
  return DEFAULT_BANNERS[type] || null;
}

export default function Dashboard() {
  const { user, logout, showToast, updateUser } = useAuth();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const [events, setEvents] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [createStep, setCreateStep] = useState(1);
  const [newEvent, setNewEvent] = useState({ title: '', event_type: '', event_date: '', event_time: '', custom_time: '', location: '', estimated_guests: '', budget: '', description: '', dress_code: '', theme_color: '' });
  const [cropperImage, setCropperImage] = useState(null);
  const [customType, setCustomType] = useState('');
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [showNotifs, setShowNotifs] = useState(false);
  const [notifToast, setNotifToast] = useState(null);
  const [notifToastExiting, setNotifToastExiting] = useState(false);
  const knownNotifIds = useRef(new Set());
const avatarRef = useRef(null);
  const notifToastTimer = useRef(null);
  const [showSettings, setShowSettings] = useState(false);
  const [settingsTab, setSettingsTab] = useState('');
  const [soundOn, setSoundOn] = useState(localStorage.getItem('ggr_sound') !== 'off');
  const [pushEnabled, setPushEnabled] = useState(localStorage.getItem('ggr_push') !== 'off');
  const [pushSupported, setPushSupported] = useState(false);
  const [pushPermission, setPushPermission] = useState('default');
  const [profileForm, setProfileForm] = useState({ name: '' });
  const [passwordForm, setPasswordForm] = useState({ current: '', new_password: '', confirm: '' });
  const [feedbackForm, setFeedbackForm] = useState({ rating: 5, category: 'general', message: '' });
  const [feedbackList, setFeedbackList] = useState([]);
  const [showFeedback, setShowFeedback] = useState(false);
  const [deactivateConfirm, setDeactivateConfirm] = useState({ password: '', reason: '' });
  const [showDeactivate, setShowDeactivate] = useState(false);
  const [showCelebration, setShowCelebration] = useState(false);
  const [showVendorRecs, setShowVendorRecs] = useState(false);
  const [recommendedVendors, setRecommendedVendors] = useState([]);
  const [lastCreatedEventType, setLastCreatedEventType] = useState('');
  const vendorRecTimerRef = useRef(null);
  const vendorRecShownRef = useRef(false);
  const [todos, setTodos] = useState([]);
  const [newTodo, setNewTodo] = useState('');
  const [showTodos, setShowTodos] = useState(true);


  const [hostWallet, setHostWallet] = useState(null);
  const [hostWalletTxns, setHostWalletTxns] = useState([]);
  const [hostBanking, setHostBanking] = useState(null);
  const [bankingForm, setBankingForm] = useState({ bank_name: '', account_holder: '', account_number: '', branch_code: '', account_type: 'cheque' });
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [kycFile, setKycFile] = useState(null);
  const [kycDocType, setKycDocType] = useState('id_book');
  const [uploadingKyc, setUploadingKyc] = useState(false);
  const [showWalletCard, setShowWalletCard] = useState(false);
  const [walletSubTab, setWalletSubTab] = useState('overview');
  const [kycStatus, setKycStatus] = useState(null);
  const [kycRejectionReason, setKycRejectionReason] = useState('');
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [showAddCard, setShowAddCard] = useState(false);
  const [cardForm, setCardForm] = useState({ card_last4: '', card_brand: 'visa', card_holder: '', expiry_month: '', expiry_year: '' });
  const [topUpAmount, setTopUpAmount] = useState('');
  const [topUpPaymentMethodId, setTopUpPaymentMethodId] = useState('');
  const [topUpLoading, setTopUpLoading] = useState(false);

  const [searchParams] = useSearchParams();

  useEffect(() => { loadEvents(); loadNotifications(); loadTodos(); loadWallet(); loadPaymentMethods(); }, []);
  useEffect(() => { if (user) setProfileForm({ name: user.name || '' }); }, [user]);
  // Check push notification support
  useEffect(() => {
    const supported = !!(('Notification' in window) && ('serviceWorker' in navigator) && ('PushManager' in window));
    setPushSupported(supported);
    if (supported) setPushPermission(Notification.permission);
    // Auto-subscribe by default (unless user explicitly opted out)
    const pushOff = localStorage.getItem('ggr_push') === 'off';
    if (supported && !pushOff) {
      if (Notification.permission === 'granted') {
        navigator.serviceWorker.ready.then(reg => reg.pushManager.getSubscription().then(sub => {
          if (!sub) subscribeToPush(); // re-subscribe
        }));
      } else if (Notification.permission === 'default') {
        // Never asked — prompt automatically so push works out of the box
        subscribeToPush().then(() => setPushPermission(Notification.permission));
      }
    }
  }, []);

  // Poll for new notifications every 30s and play sound on new ones
  useEffect(() => {
    let prevCount = 0;
    const poll = setInterval(async () => {
      try {
        const r = await api.get('/notifications');
        const newUnread = r.data.filter(n => !n.read).length;

        // Show WhatsApp-style toast for genuinely new notifications
        const newOnes = r.data.filter(n => !knownNotifIds.current.has(n.id) && !n.read);
        if (newOnes.length > 0 && prevCount > 0) {
          const latest = newOnes[0]; // most recent first from API
          setNotifToastExiting(false);
          setNotifToast(latest);
          clearTimeout(notifToastTimer.current);
          notifToastTimer.current = setTimeout(() => {
            setNotifToastExiting(true);
            setTimeout(() => { setNotifToast(null); setNotifToastExiting(false); }, 300);
          }, 5000);
        }
        // Track all known IDs
        r.data.forEach(n => knownNotifIds.current.add(n.id));

        if (newUnread > prevCount && prevCount > 0 && localStorage.getItem('ggr_sound') !== 'off') {
          playNotificationSound();
          try { if (navigator.setAppBadge) navigator.setAppBadge(newUnread); } catch {}
        } else if (newUnread !== prevCount) {
          try { if (navigator.setAppBadge) { if (newUnread > 0) navigator.setAppBadge(newUnread); else navigator.clearAppBadge(); } } catch {}
        }
        prevCount = newUnread;
        setNotifications(r.data);
      } catch {}
    }, 30000);
    return () => clearInterval(poll);
  }, []);

  // Auto-open create modal from Kgatso or partner links, or wallet section
  useEffect(() => {
    const autoCreate = searchParams.get('create');
    const eventType = searchParams.get('event_type');
    const section = searchParams.get('section');
    const showVendorRec = searchParams.get('show_vendor_rec');
    if (autoCreate === 'true' && eventType) {
      setNewEvent(prev => ({ ...prev, event_type: eventType }));
      setShowCreate(true);
      setCreateStep(2);
    }
    if (section === 'wallet' && user?.role !== 'vendor') {
      setShowWalletCard(true);
      loadWallet();
    }
    if (showVendorRec === '1') {
      sessionStorage.removeItem('vendor_rec_dismissed');
      const recType = eventType || EVENT_TYPES[Math.floor(Math.random() * EVENT_TYPES.length)];
      setLastCreatedEventType(recType);
      fetchRecommendedVendors(recType).then(() => setShowVendorRecs(true));
    }
  }, [searchParams, user?.role]);

  // Keep a mutable ref for events to avoid stale closure in the gigi-action listener
  const eventsRef = useRef(events);
  useEffect(() => { eventsRef.current = events; }, [events]);

  // Listen for GiGi quick-chip navigation events (same as EventWorkspace)
  useEffect(() => {
    const handler = (e) => {
      const { action, tab: targetTab, filter, vendorName } = e.detail || {};
      const latestEvents = eventsRef.current;
      if (action === 'navigate' && targetTab) {
        if (latestEvents.length > 0) {
          navigate(`/event/${latestEvents[0].id}?tab=${targetTab}`);
          if (filter) sessionStorage.setItem('ggr_vendor_filter', filter);
        }
      } else if (action === 'open_vendor_chat' && vendorName) {
        if (latestEvents.length > 0) {
          navigate(`/event/${latestEvents[0].id}?tab=vendors`);
          sessionStorage.setItem('ggr_open_vendor_chat', vendorName);
        }
      }
    };
    window.addEventListener('gigi-action', handler);
    return () => window.removeEventListener('gigi-action', handler);
  }, [navigate]);

  // Listen for notification bell clicks from AppLayout
  useEffect(() => {
    const handler = () => setShowNotifs(true);
    window.addEventListener('open-notifications', handler);
    return () => window.removeEventListener('open-notifications', handler);
  }, []);

  // Handle "Add Event" tap from bottom nav — open create modal via navigation state
  useEffect(() => {
    if (location.state?.openCreate) {
      setShowCreate(true);
      navigate('/dashboard', { replace: true, state: {} });
    }
    if (location.state?.openGigi) {
      navigate('/dashboard', { replace: true, state: {} });
      // Dispatch after a tick so GigiBot's listener is mounted
      setTimeout(() => window.dispatchEvent(new CustomEvent('gigi-open')), 50);
    }
    if (location.state?.openFeedback) {
      setShowFeedback(true);
      navigate('/dashboard', { replace: true, state: {} });
    }
    if (location.state?.openWallet) {
      setShowWalletCard(true);
      loadWallet();
      navigate('/dashboard', { replace: true, state: {} });
    }
    if (location.state?.openSettings) {
      setShowSettings(true);
      navigate('/dashboard', { replace: true, state: {} });
    }
  }, [location.state?.openCreate, location.state?.openGigi, location.state?.openFeedback, location.state?.openWallet, location.state?.openSettings, navigate]);

  // Toggle settings modal from external triggers (e.g. mobile header gear icon)
  useEffect(() => {
    const handler = () => setShowSettings(prev => !prev);
    window.addEventListener('settings-toggle', handler);
    return () => window.removeEventListener('settings-toggle', handler);
  }, []);

  // Toggle create modal from bottom nav Event button re-tap
  useEffect(() => {
    const handler = () => setShowCreate(prev => !prev);
    window.addEventListener('create-event-toggle', handler);
    return () => window.removeEventListener('create-event-toggle', handler);
  }, []);

  // Random vendor recommendation popup — fires once per session after a delay
  useEffect(() => {
    if (sessionStorage.getItem('vendor_rec_dismissed')) return;
    // Don't queue if already showing from event creation
    if (vendorRecShownRef.current) return;
    const delay = 40000 + Math.random() * 140000; // 40–180 seconds
    vendorRecTimerRef.current = setTimeout(async () => {
      // Don't show if user is mid-event-creation or viewing another modal
      if (showCelebration || showVendorRecs || showCreate) return;
      vendorRecShownRef.current = true;
      const randomType = EVENT_TYPES[Math.floor(Math.random() * EVENT_TYPES.length)];
      setLastCreatedEventType(randomType);
      await fetchRecommendedVendors(randomType);
      setShowVendorRecs(true);
    }, delay);
    return () => {
      if (vendorRecTimerRef.current) clearTimeout(vendorRecTimerRef.current);
    };
  }, []);

  const loadNotifications = async () => {
    try {
      const r = await api.get('/notifications');
      setNotifications(r.data);
      r.data.forEach(n => knownNotifIds.current.add(n.id));
      const unread = r.data.filter(n => !n.read).length;
      try { if (navigator.setAppBadge) { if (unread > 0) navigator.setAppBadge(unread); else navigator.clearAppBadge(); } } catch {}
    } catch {}
  };

  const loadTodos = async () => {
    try { const r = await api.get('/todos'); setTodos(r.data); } catch {}
  };

  const addTodo = async () => {
    if (!newTodo.trim()) return;
    try {
      await api.post('/todos', { title: newTodo.trim() });
      setNewTodo('');
      loadTodos();
    } catch { showToast('Failed to add task', 'error'); }
  };

  const toggleTodo = async (id, completed) => {
    try {
      await api.put(`/todos/${id}`, { completed: !completed });
      loadTodos();
    } catch {}
  };

  const deleteTodo = async (id) => {
    try {
      await api.delete(`/todos/${id}`);
      loadTodos();
    } catch {}
  };

  const loadWallet = async () => {
    try {
      const [walletRes, bankingRes] = await Promise.all([
        api.get('/host/wallet'),
        api.get('/host/banking'),
      ]);
      setHostWallet(walletRes.data);
      setHostWalletTxns(walletRes.data?.transactions || []);
      setHostBanking(bankingRes.data || null);
      if (bankingRes.data?.kyc_status) setKycStatus(bankingRes.data.kyc_status);
      if (bankingRes.data?.kyc_rejection_reason) setKycRejectionReason(bankingRes.data.kyc_rejection_reason);
    } catch {}
  };

  const loadPaymentMethods = async () => {
    try {
      const r = await api.get('/host/payment-methods');
      setPaymentMethods(r.data || []);
    } catch {}
  };

  const submitKycDocuments = async () => {
    if (!kycFile) return showToast('Please select a document to upload', 'error');
    setUploadingKyc(true);
    try {
      const fd = new FormData();
      fd.append('document_type', kycDocType);
      fd.append('front', kycFile);
      await api.post('/user/upload-kyc', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      showToast('KYC document submitted for review');
      setKycStatus('pending');
      setKycRejectionReason('');
      setKycFile(null);
    } catch (e) {
      showToast(e.response?.data?.error || 'Failed to upload document', 'error');
    } finally {
      setUploadingKyc(false);
    }
  };

  const markNotificationsRead = async () => {
    try {
      await api.put('/notifications/read-all');
      setNotifications(n => n.map(x => ({ ...x, read: true })));
      try { if (navigator.clearAppBadge) navigator.clearAppBadge(); } catch {}
    } catch {}
  };

  // Mark a single notification read (so it stays until the user actually opens it)
  const markNotificationRead = async (id) => {
    setNotifications(n => n.map(x => x.id === id ? { ...x, read: true } : x));
    try { await api.put(`/notifications/${id}/read`); } catch {}
    try {
      const unread = notifications.filter(x => !x.read && x.id !== id).length;
      if (navigator.setAppBadge) { if (unread > 0) navigator.setAppBadge(unread); else navigator.clearAppBadge(); }
    } catch {}
  };


  const loadEvents = async () => {
    const minDelay = new Promise(r => setTimeout(r, 4000));
    try {
      const res = await api.get('/events');
      setEvents(res.data);
    } catch {} finally { await minDelay; setLoading(false); }
  };

  const markRsvpsViewed = async (eventId) => {
    try {
      await api.post(`/events/${eventId}/mark-rsvps-viewed`);
      setEvents(prev => prev.map(e => e.id === eventId ? { ...e, new_rsvp_count: 0 } : e));
    } catch {}
  };

  const markContributionsViewed = async (eventId) => {
    try {
      await api.post(`/events/${eventId}/mark-contributions-viewed`);
      setEvents(prev => prev.map(e => e.id === eventId ? { ...e, new_gift_contributions: 0 } : e));
    } catch {}
  };

  const markTicketsViewed = async (eventId) => {
    try {
      await api.post(`/events/${eventId}/mark-tickets-viewed`);
      setEvents(prev => prev.map(e => e.id === eventId ? { ...e, new_ticket_sales: 0 } : e));
    } catch {}
  };

  const changePassword = async () => {
    if (passwordForm.new_password.length < 6) return showToast('Password must be at least 6 characters', 'error');
    if (passwordForm.new_password !== passwordForm.confirm) return showToast('Passwords do not match', 'error');
    try {
      await api.put('/auth/change-password', { current_password: passwordForm.current, new_password: passwordForm.new_password });
      showToast('Password updated successfully!');
      setPasswordForm({ current: '', new_password: '', confirm: '' });
    } catch (e) {
      showToast(e.response?.data?.error || 'Failed to change password', 'error');
    }
  };

  const updateName = async () => {
    try {
      await api.put('/auth/profile', { name: profileForm.name });
      updateUser({ ...user, name: profileForm.name });
      showToast('Name updated!');
    } catch { showToast('Failed to update', 'error'); }
  };

  const handleAvatarUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('avatar', file);
    try {
      const r = await api.put('/auth/avatar', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      if (r.data.token) {
        localStorage.setItem('ggr_token', r.data.token);
        updateUser(r.data.user);
      }
      showToast('Profile photo updated!');
    } catch { showToast('Upload failed', 'error'); }
  };

  const submitFeedback = async () => {
    if (!feedbackForm.message.trim()) return showToast('Please enter your feedback', 'error');
    try {
      await api.post('/feedback', { ...feedbackForm, page: 'dashboard' });
      showToast('Thank you for your feedback!');
      setFeedbackForm({ rating: 5, category: 'general', message: '' });
      setShowFeedback(false);
      loadFeedback();
    } catch { showToast('Failed to submit', 'error'); }
  };

  const loadFeedback = async () => {
    try { const r = await api.get('/feedback'); setFeedbackList(r.data); } catch {}
  };

  const deactivateAccount = async () => {
    if (!deactivateConfirm.password) return showToast('Enter your password to confirm', 'error');
    try {
      await api.post('/auth/deactivate', deactivateConfirm);
      showToast('Account deactivated');
      logout();
    } catch (e) {
      showToast(e.response?.data?.error || 'Failed', 'error');
    }
  };

  const fetchRecommendedVendors = async (eventType) => {
    try {
      const res = await api.get('/vendors');
      const allVendors = (res.data || []).filter(v => v.business_name && v.business_category);
      const targetCategories = EVENT_VENDOR_MAP[eventType] || EVENT_VENDOR_MAP['Custom Event'];
      // Filter vendors whose served_event_types includes the event type OR business_category matches
      const matched = allVendors.filter(v => {
        const served = Array.isArray(v.served_event_types) ? v.served_event_types.map(s => s.toLowerCase()) : [];
        const categoryMatch = targetCategories.some(cat =>
          served.includes(eventType.toLowerCase()) ||
          (v.business_category && v.business_category.toLowerCase().includes(cat.toLowerCase()))
        );
        return categoryMatch;
      });
      // Sort by rating desc
      matched.sort((a, b) => (b.avg_rating || 0) - (a.avg_rating || 0));
      // Fallback: if no specific matches, show top 4 highest-rated vendors
      if (matched.length === 0) {
        allVendors.sort((a, b) => (b.avg_rating || 0) - (a.avg_rating || 0));
        setRecommendedVendors(allVendors.slice(0, 4));
      } else {
        setRecommendedVendors(matched.slice(0, 4));
      }
    } catch (err) {
      console.error('fetchRecommendedVendors failed:', err);
      setRecommendedVendors([]);
    }
  };

  const createEvent = async () => {
    try {
      const fd = new FormData();
      fd.append('title', newEvent.title);
      fd.append('event_type', newEvent.event_type === 'Custom Event' ? customType : newEvent.event_type);
      if (newEvent.event_date) fd.append('event_date', newEvent.event_date);
      // Use custom_time if selected, otherwise use the dropdown value
      const timeVal = newEvent.event_time === 'custom' ? newEvent.custom_time : newEvent.event_time;
      if (timeVal) fd.append('event_time_str', timeVal);
      fd.append('location', newEvent.location || '');
      fd.append('estimated_guests', newEvent.estimated_guests || '0');
      fd.append('budget', newEvent.budget || '0');
      if (newEvent.coverFile) fd.append('cover_image', newEvent.coverFile);
      if (newEvent.description) fd.append('description', newEvent.description);
      if (newEvent.dress_code) fd.append('dress_code', newEvent.dress_code);
      if (newEvent.theme_color) fd.append('theme_color', newEvent.theme_color);
      await api.post('/events', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      showToast('Event created successfully!');
      const createdEventType = newEvent.event_type === 'Custom Event' ? customType : newEvent.event_type;
      setShowCreate(false);
      setCreateStep(1);
      setCustomType('');
      setNewEvent({ title: '', event_type: '', event_date: '', event_time: '', custom_time: '', location: '', estimated_guests: '', budget: '', description: '', dress_code: '', theme_color: '' });
      setLastCreatedEventType(createdEventType);
      // Show balloon celebration on every new event
      setShowCelebration(true);
      setTimeout(async () => {
        setShowCelebration(false);
        // Fetch vendor recommendations after celebration
        await fetchRecommendedVendors(createdEventType);
        setShowVendorRecs(true);
      }, 5000);
      loadEvents();
    } catch {
      showToast('Failed to create event', 'error');
    }
  };

  if (user?.role === 'vendor') { navigate('/vendor-dashboard'); return null; } // pure vendor only

  const unreadNotifs = notifications.filter(n => !n.read).length;

  function SettingsRow({ icon, iconBg, iconColor, label, onClick, danger, isLast }) {
    const coloredIcon = React.cloneElement(icon, { color: iconColor });
    return (
      <button
        onClick={onClick}
        style={{
          display: 'flex', alignItems: 'center', gap: '14px', padding: '14px 20px',
          width: '100%', border: 'none', background: 'transparent', cursor: 'pointer',
          fontFamily: 'Inter, sans-serif',
          borderBottom: isLast ? 'none' : '1px solid rgba(0,0,0,0.04)',
        }}
      >
        <div style={{ width: '40px', height: '40px', borderRadius: '12px', background: iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          {coloredIcon}
        </div>
        <span style={{ flex: 1, textAlign: 'left', fontSize: '15px', fontWeight: 500, color: danger ? '#DC2626' : 'var(--dark)' }}>{label}</span>
        <FiChevronRight size={18} color="var(--gray)" />
      </button>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--cream)' }}>
      <style>{`
        @keyframes rsvpPulse {
          0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4); }
          50% { transform: scale(1.22); box-shadow: 0 0 0 6px rgba(16, 185, 129, 0); }
        }
      `}</style>
      <div className="container" style={{ padding: '32px 20px' }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '32px' }}>
          <div>
            <h2 style={{ fontSize: '28px', marginBottom: '8px' }}>My Dashboard</h2>
            <p style={{ color: 'var(--gray)' }}>Welcome back, {user?.name}. Let's plan something beautiful.</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <button onClick={() => navigate('/settings')} className="btn btn-icon" style={{ width: '36px', height: '36px', borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--gray)' }}>
              <FiSettings size={18} />
            </button>
            {!isMobile && <ThemeToggle />}
            {!isMobile && (
              <button onClick={logout} className="btn btn-outline btn-sm" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                <FiLogOut size={14} /> Logout
              </button>
            )}
          </div>
        </div>

        {/* Quick Actions — 3 clean icon buttons */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '32px', maxWidth: '480px' }}>
          <button onClick={() => { setShowCreate(true); setCreateStep(1); }} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', background: 'none', border: 'none', cursor: 'pointer', padding: '8px 0' }}>
            <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'radial-gradient(circle at 35% 35%, #3a3a3e, #1c1c1e)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 16px rgba(28,28,30,0.35), inset 0 1px 0 rgba(255,255,255,0.08)', position: 'relative', flexShrink: 0 }}>
              <FiCalendar size={22} color="#fff" style={{ filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.3))' }} />
              <FiPlus size={14} color="#1c1c1e" strokeWidth={3} style={{ position: 'absolute', bottom: '-3px', right: '-3px', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.4))' }} />
            </div>
            <span style={{ fontSize: '12px', fontWeight: 600, color: 'var(--dark)', textAlign: 'center', lineHeight: 1.3 }}>Add New Event</span>
          </button>
          <Link to="/vendors" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', textDecoration: 'none', padding: '8px 0' }}>
            <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'radial-gradient(circle at 35% 35%, #f0808e, #d13a4f)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 16px rgba(227,66,92,0.4), inset 0 1px 0 rgba(255,255,255,0.12)', position: 'relative', flexShrink: 0 }}>
              <HiOutlineBuildingStorefront size={22} color="#fff" style={{ filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.25))' }} />
              <FiSearch size={14} color="#d13a4f" strokeWidth={3} style={{ position: 'absolute', bottom: '-3px', right: '-3px', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.4))' }} />
            </div>
            <span style={{ fontSize: '12px', fontWeight: 600, color: 'var(--dark)', textAlign: 'center', lineHeight: 1.3 }}>Explore Vendors</span>
          </Link>
          <button onClick={() => setShowFeedback(true)} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', background: 'none', border: 'none', cursor: 'pointer', padding: '8px 0' }}>
            <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'radial-gradient(circle at 35% 35%, #34d399, #059669)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 16px rgba(16,185,129,0.4), inset 0 1px 0 rgba(255,255,255,0.12)', position: 'relative', flexShrink: 0 }}>
              <FiStar size={22} color="#fff" style={{ filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.25))' }} />
              <FiThumbsUp size={14} color="#059669" strokeWidth={3} style={{ position: 'absolute', bottom: '-3px', right: '-3px', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.4))' }} />
            </div>
            <span style={{ fontSize: '12px', fontWeight: 600, color: 'var(--dark)', textAlign: 'center', lineHeight: 1.3 }}>Give Feedback</span>
          </button>
        </div>

        {/* Owner To-Do List — admin only */}
        {user?.is_admin && <div className="card" style={{ marginBottom: '32px', padding: '24px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <h3 style={{ fontSize: '18px', margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FiCheckCircle size={20} color="var(--rose)" /> My To-Do List
            </h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '13px', color: 'var(--gray)' }}>
                {todos.filter(t => t.completed).length}/{todos.length} done
              </span>
              <button onClick={() => setShowTodos(!showTodos)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: 'var(--gray)', fontSize: '12px' }}>
                {showTodos ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>
          {todos.length > 0 && (
            <div className="progress-bar" style={{ marginBottom: '16px' }}>
              <div className="progress-fill" style={{ width: `${todos.length ? (todos.filter(t => t.completed).length / todos.length) * 100 : 0}%` }}></div>
            </div>
          )}
          {showTodos && (
            <>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                <input
                  value={newTodo}
                  onChange={e => setNewTodo(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && addTodo()}
                  placeholder="Add a new task..."
                  style={{ flex: 1, padding: '10px 14px', borderRadius: '10px', border: '1px solid var(--border)', fontSize: '14px', background: 'var(--cream)' }}
                />
                <button onClick={addTodo} className="btn btn-primary btn-sm" style={{ borderRadius: '10px', padding: '10px 16px' }}>
                  <FiPlus size={16} />
                </button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxHeight: '300px', overflowY: 'auto' }}>
                {todos.map(todo => (
                  <div key={todo.id} style={{
                    display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px',
                    borderRadius: '10px', background: todo.completed ? 'var(--cream)' : 'transparent',
                    transition: 'all 0.2s'
                  }}>
                    <button
                      onClick={() => toggleTodo(todo.id, todo.completed)}
                      style={{
                        width: '22px', height: '22px', borderRadius: '50%', flexShrink: 0, cursor: 'pointer',
                        border: todo.completed ? 'none' : '2px solid var(--border)',
                        background: todo.completed ? 'var(--rose)' : 'transparent',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0
                      }}
                    >
                      {todo.completed && <FiCheck size={13} color="white" strokeWidth={3} />}
                    </button>
                    <span style={{
                      flex: 1, fontSize: '14px',
                      textDecoration: todo.completed ? 'line-through' : 'none',
                      color: todo.completed ? 'var(--gray)' : 'var(--dark)',
                      opacity: todo.completed ? 0.6 : 1
                    }}>
                      {todo.title}
                    </span>
                    <button
                      onClick={() => deleteTodo(todo.id)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: 'var(--gray)', opacity: 0.5 }}
                    >
                      <FiTrash2 size={14} />
                    </button>
                  </div>
                ))}
                {todos.length === 0 && (
                  <p style={{ textAlign: 'center', color: 'var(--gray)', fontSize: '14px', padding: '16px 0' }}>
                    No tasks yet. Add your first task above!
                  </p>
                )}
              </div>
            </>
          )}
        </div>}

        {/* Host Wallet — Premium Digital Wallet */}
        {user?.role !== 'vendor' && showWalletCard && (
        <div className="card" style={{ marginBottom: '32px', padding: '0', overflow: 'hidden' }}>
          {/* Gradient wallet card — bank card style */}
          <div style={{
            background: 'linear-gradient(135deg, #1a1a2e 0%, #2d1b3d 50%, #1a1a2e 100%)',
            padding: '28px 28px 20px', position: 'relative', overflow: 'hidden'
          }}>
            {/* Decorative circles */}
            <div style={{ position: 'absolute', top: -30, right: -20, width: 140, height: 140, borderRadius: '50%', background: 'rgba(232,160,191,0.08)', pointerEvents: 'none' }} />
            <div style={{ position: 'absolute', bottom: -40, left: -30, width: 120, height: 120, borderRadius: '50%', background: 'rgba(212,168,83,0.06)', pointerEvents: 'none' }} />
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                <div>
                  <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '4px' }}>My Wallet</div>
                  <div style={{ fontSize: '32px', fontWeight: 700, color: '#fff', lineHeight: 1 }}>
                    R{Number(hostWallet?.available_balance || 0).toLocaleString()}
                  </div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.45)', marginTop: '2px' }}>Available Balance</div>
                </div>
                <button
                  onClick={(e) => { e.stopPropagation(); setShowWalletCard(false); }}
                  style={{ background: 'rgba(255,255,255,0.1)', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,0.6)', padding: '6px', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  <FiX size={16} />
                </button>
              </div>
              {/* Quick stats row */}
              <div style={{ display: 'flex', gap: '24px' }}>
                <div>
                  <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '1px' }}>Total Earned</div>
                  <div style={{ fontSize: '14px', fontWeight: 600, color: 'rgba(255,255,255,0.8)' }}>R{Number(hostWallet?.total_earned || 0).toLocaleString()}</div>
                </div>
                <div>
                  <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '1px' }}>Withdrawn</div>
                  <div style={{ fontSize: '14px', fontWeight: 600, color: 'rgba(255,255,255,0.8)' }}>R{Number(hostWallet?.total_withdrawn || 0).toLocaleString()}</div>
                </div>
                <div>
                  <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '1px' }}>KYC</div>
                  <div style={{ fontSize: '14px', fontWeight: 600, color: hostBanking?.kyc_status === 'approved' ? '#4ade80' : hostBanking?.kyc_status === 'pending' ? '#fbbf24' : 'rgba(255,255,255,0.5)' }}>
                    {hostBanking?.kyc_status === 'approved' ? 'Verified' : hostBanking?.kyc_status === 'pending' ? 'Pending' : 'Unverified'}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick action buttons */}
          <div style={{ display: 'flex', gap: '10px', padding: '16px 24px', borderBottom: '1px solid var(--cream-dark)' }}>
            <button onClick={() => { setWalletSubTab('cards'); setTopUpAmount(''); }} style={{
              flex: 1, padding: '10px', borderRadius: '10px', background: 'linear-gradient(135deg, #E8A0BF, #D4A853)',
              color: '#fff', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
            }}>
              <FiArrowDown size={16} /> Top Up
            </button>
            <button onClick={() => setWalletSubTab('withdraw')} style={{
              flex: 1, padding: '10px', borderRadius: '10px',
              background: 'var(--cream)', color: 'var(--dark)', border: '1px solid var(--cream-dark)',
              cursor: 'pointer', fontSize: '13px', fontWeight: 600,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
            }}>
              <FiArrowUp size={16} /> Withdraw
            </button>
            <button onClick={() => setWalletSubTab('cards')} style={{
              flex: 1, padding: '10px', borderRadius: '10px',
              background: 'var(--cream)', color: 'var(--dark)', border: '1px solid var(--cream-dark)',
              cursor: 'pointer', fontSize: '13px', fontWeight: 600,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
            }}>
              <FiCreditCard size={16} /> Cards
            </button>
          </div>

          {/* Sub-tab bar */}
          <div style={{ display: 'flex', borderBottom: '1px solid var(--cream-dark)', padding: '0 24px', gap: '0' }}>
            {[
              { key: 'overview', label: 'Overview' },
              { key: 'cards', label: 'Payment Methods' },
              { key: 'banking', label: 'Banking + KYC' },
              { key: 'withdraw', label: 'Withdraw' },
            ].map(t => (
              <button key={t.key} onClick={() => setWalletSubTab(t.key)} style={{
                padding: '10px 18px', fontSize: '13px', fontWeight: walletSubTab === t.key ? 600 : 400,
                background: 'none', border: 'none',
                borderBottom: walletSubTab === t.key ? '2px solid var(--rose)' : '2px solid transparent',
                color: walletSubTab === t.key ? 'var(--rose)' : 'var(--gray)',
                cursor: 'pointer', transition: 'all 0.2s'
              }}>{t.label}</button>
            ))}
          </div>

          <div style={{ padding: '24px' }}>
            {/* OVERVIEW SUB-TAB */}
            {walletSubTab === 'overview' && (
              <div>
                {hostWallet ? (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px', marginBottom: '24px' }}>
                    <div style={{ padding: '16px', borderRadius: '12px', background: 'var(--cream)', textAlign: 'center' }}>
                      <FiArrowDown size={16} color="var(--gray)" style={{ marginBottom: '6px' }} />
                      <div style={{ fontSize: '11px', color: 'var(--gray)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Available</div>
                      <div style={{ fontSize: '20px', fontWeight: 700, color: 'var(--dark)' }}>R{Number(hostWallet.available_balance || 0).toLocaleString()}</div>
                    </div>
                    <div style={{ padding: '16px', borderRadius: '12px', background: 'var(--cream)', textAlign: 'center' }}>
                      <WalletIcon size={16} color="var(--gray)" style={{ marginBottom: '6px' }} />
                      <div style={{ fontSize: '11px', color: 'var(--gray)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Total Earned</div>
                      <div style={{ fontSize: '20px', fontWeight: 700, color: 'var(--dark)' }}>R{Number(hostWallet.total_earned || 0).toLocaleString()}</div>
                    </div>
                    <div style={{ padding: '16px', borderRadius: '12px', background: 'var(--cream)', textAlign: 'center' }}>
                      <FiArrowUp size={16} color="var(--gray)" style={{ marginBottom: '6px' }} />
                      <div style={{ fontSize: '11px', color: 'var(--gray)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Withdrawn</div>
                      <div style={{ fontSize: '20px', fontWeight: 700, color: 'var(--dark)' }}>R{Number(hostWallet.total_withdrawn || 0).toLocaleString()}</div>
                    </div>
                    <div style={{ padding: '16px', borderRadius: '12px', background: 'var(--cream)', textAlign: 'center' }}>
                      <FiCreditCard size={16} color="var(--gray)" style={{ marginBottom: '6px' }} />
                      <div style={{ fontSize: '11px', color: 'var(--gray)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Saved Cards</div>
                      <div style={{ fontSize: '20px', fontWeight: 700, color: 'var(--dark)' }}>{paymentMethods.length}</div>
                    </div>
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                    <CoinIcon size={48} color="var(--gray)" style={{ opacity: 0.3 }} />
                    <p style={{ color: 'var(--gray)', marginTop: '12px' }}>No wallet activity yet. Your earnings will appear here.</p>
                  </div>
                )}

                {/* Recent transactions */}
                {hostWalletTxns.length > 0 ? (
                  <div>
                    <h4 style={{ fontSize: '14px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <FiClock size={14} /> Recent Transactions
                    </h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      {hostWalletTxns.slice(0, 8).map((txn, i) => {
                        const isCredit = txn.type === 'credit' || txn.type === 'top_up' || txn.amount > 0;
                        return (
                        <div key={txn.id || i} style={{
                          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                          padding: '10px 14px', borderRadius: '10px', background: 'var(--cream)',
                          fontSize: '13px'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                              width: '34px', height: '34px', borderRadius: '50%',
                              background: isCredit ? 'rgba(16,185,129,0.1)' : 'rgba(255,107,107,0.08)',
                              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                            }}>
                              {isCredit ? <FiArrowDown size={14} color="#10B981" /> : <FiArrowUp size={14} color="#FF6B6B" />}
                            </div>
                            <div>
                              <div style={{ fontWeight: 500 }}>{txn.description || txn.type || 'Transaction'}</div>
                              <div style={{ fontSize: '11px', color: 'var(--gray)' }}>
                                {txn.created_at ? new Date(txn.created_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}
                                {txn.status === 'completed' ? '' : ` · ${txn.status}`}
                              </div>
                            </div>
                          </div>
                          <span style={{ fontWeight: 600, color: isCredit ? '#10B981' : 'var(--dark)' }}>
                            {isCredit ? '+' : '-'}R{Math.abs(txn.amount || 0).toLocaleString()}
                          </span>
                        </div>
                        );
                      })}
                    </div>
                  </div>
                ) : hostWallet ? (
                  <p style={{ textAlign: 'center', color: 'var(--gray)', fontSize: '13px', padding: '20px 0' }}>No transactions yet.</p>
                ) : null}
              </div>
            )}

            {/* PAYMENT METHODS SUB-TAB */}
            {walletSubTab === 'cards' && (
              <div>
                {/* Saved cards list */}
                {paymentMethods.length > 0 && (
                  <div style={{ marginBottom: '20px' }}>
                    <h4 style={{ fontSize: '14px', marginBottom: '10px' }}>Saved Cards</h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {paymentMethods.map((pm) => (
                        <div key={pm.id} style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                          padding: '12px 14px', borderRadius: '10px', background: 'var(--cream)',
                          border: pm.is_default ? '1px solid rgba(212,168,83,0.3)' : '1px solid transparent'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                              width: '38px', height: '38px', borderRadius: '8px',
                              background: 'linear-gradient(135deg, #1a1a2e, #2d1b3d)',
                              display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                              <FiCreditCard size={18} color="#fff" />
                            </div>
                            <div>
                              <div style={{ fontWeight: 600, fontSize: '13px', textTransform: 'capitalize' }}>
                                {pm.card_brand} <span style={{ fontWeight: 400, color: 'var(--gray)' }}>****{pm.card_last4}</span>
                              </div>
                              <div style={{ fontSize: '11px', color: 'var(--gray)' }}>
                                {pm.card_holder || 'No name'} {pm.expiry_month ? `· Exp ${String(pm.expiry_month).padStart(2,'0')}/${pm.expiry_year || '--'}` : ''}
                                {pm.is_default ? <span style={{ color: '#D4A853', fontWeight: 600, marginLeft: '6px' }}>Default</span> : null}
                              </div>
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '4px' }}>
                            {!pm.is_default && (
                              <button onClick={async () => {
                                try { await api.put(`/host/payment-methods/${pm.id}/default`); loadPaymentMethods(); showToast('Default card updated'); } catch {}
                              }} style={{
                                background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)',
                                padding: '4px', fontSize: '11px'
                              }} title="Set as default">Set default</button>
                            )}
                            <button onClick={async () => {
                              if (!window.confirm('Remove this card?')) return;
                              try { await api.delete(`/host/payment-methods/${pm.id}`); loadPaymentMethods(); showToast('Card removed'); } catch (e) { showToast('Failed to remove', 'error'); }
                            }} style={{
                              background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)',
                              padding: '4px'
                            }}><FiTrash2 size={14} /></button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Add new card */}
                {showAddCard ? (
                  <div style={{ padding: '16px', borderRadius: '12px', background: 'var(--cream)', marginBottom: '16px' }}>
                    <h4 style={{ fontSize: '14px', marginBottom: '12px' }}>Add New Card</h4>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                      <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                        <label style={{ fontSize: '12px' }}>Card Number (last 4 digits)</label>
                        <input value={cardForm.card_last4} onChange={e => setCardForm({ ...cardForm, card_last4: e.target.value.replace(/\D/g,'').slice(0,4) })} placeholder="1234" maxLength={4} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }} />
                      </div>
                      <div className="form-group">
                        <label style={{ fontSize: '12px' }}>Card Brand</label>
                        <select value={cardForm.card_brand} onChange={e => setCardForm({ ...cardForm, card_brand: e.target.value })} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', background: 'var(--white)' }}>
                          <option value="visa">Visa</option>
                          <option value="mastercard">Mastercard</option>
                          <option value="amex">American Express</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label style={{ fontSize: '12px' }}>Card Holder</label>
                        <input value={cardForm.card_holder} onChange={e => setCardForm({ ...cardForm, card_holder: e.target.value })} placeholder="Name on card" style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }} />
                      </div>
                      <div className="form-group">
                        <label style={{ fontSize: '12px' }}>Expiry Month</label>
                        <input type="number" value={cardForm.expiry_month} onChange={e => setCardForm({ ...cardForm, expiry_month: e.target.value })} placeholder="MM" min="1" max="12" style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }} />
                      </div>
                      <div className="form-group">
                        <label style={{ fontSize: '12px' }}>Expiry Year</label>
                        <input type="number" value={cardForm.expiry_year} onChange={e => setCardForm({ ...cardForm, expiry_year: e.target.value })} placeholder="YYYY" min="2026" style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }} />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                      <button onClick={async () => {
                        if (!cardForm.card_last4 || cardForm.card_last4.length < 4) return showToast('Enter last 4 digits', 'error');
                        try {
                          await api.post('/host/payment-methods', { ...cardForm, expiry_month: Number(cardForm.expiry_month) || null, expiry_year: Number(cardForm.expiry_year) || null });
                          showToast('Card added!');
                          setCardForm({ card_last4: '', card_brand: 'visa', card_holder: '', expiry_month: '', expiry_year: '' });
                          setShowAddCard(false);
                          loadPaymentMethods();
                        } catch (e) { showToast(e.response?.data?.error || 'Failed to add card', 'error'); }
                      }} style={{
                        padding: '9px 20px', borderRadius: '8px', background: 'var(--rose)', color: '#fff',
                        border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600
                      }}>Save Card</button>
                      <button onClick={() => { setShowAddCard(false); setCardForm({ card_last4: '', card_brand: 'visa', card_holder: '', expiry_month: '', expiry_year: '' }); }} style={{
                        padding: '9px 20px', borderRadius: '8px', background: 'var(--cream)', color: 'var(--gray)',
                        border: '1px solid var(--cream-dark)', cursor: 'pointer', fontSize: '13px'
                      }}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <button onClick={() => setShowAddCard(true)} style={{
                    padding: '12px', borderRadius: '10px', width: '100%',
                    background: 'var(--cream)', color: 'var(--dark)', border: '2px dashed rgba(0,0,0,0.1)',
                    cursor: 'pointer', fontSize: '13px', fontWeight: 600,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                    marginBottom: '20px'
                  }}>
                    <FiPlus size={16} /> Add New Card
                  </button>
                )}

                {/* Top-up section */}
                <div style={{ borderTop: '1px solid var(--cream-dark)', paddingTop: '20px' }}>
                  <h4 style={{ fontSize: '14px', marginBottom: '4px' }}>Top Up Wallet</h4>
                  <p style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '12px' }}>
                    Add funds to your wallet using a saved payment method.
                  </p>

                  {/* Preset amounts */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px', marginBottom: '14px' }}>
                    {[50, 100, 200, 500].map(amt => (
                      <button key={amt} onClick={() => setTopUpAmount(String(amt))} style={{
                        padding: '10px', borderRadius: '8px', textAlign: 'center',
                        background: topUpAmount === String(amt) ? 'var(--rose)' : 'var(--cream)',
                        color: topUpAmount === String(amt) ? '#fff' : 'var(--dark)',
                        border: topUpAmount === String(amt) ? '2px solid var(--rose)' : '1px solid var(--cream-dark)',
                        cursor: 'pointer', fontSize: '14px', fontWeight: 600,
                        transition: 'all 0.2s'
                      }}>R{amt}</button>
                    ))}
                  </div>

                  {/* Custom amount */}
                  <div className="form-group" style={{ marginBottom: '12px' }}>
                    <label style={{ fontSize: '12px' }}>Custom Amount (R)</label>
                    <input type="number" value={topUpAmount} onChange={e => setTopUpAmount(e.target.value)} placeholder="Enter amount" min="1" style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }} />
                  </div>

                  {/* Payment method selector */}
                  {paymentMethods.length > 0 && (
                    <div className="form-group" style={{ marginBottom: '14px' }}>
                      <label style={{ fontSize: '12px' }}>Pay With</label>
                      <select value={topUpPaymentMethodId} onChange={e => setTopUpPaymentMethodId(e.target.value)} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', background: 'var(--white)' }}>
                        <option value="">Select a card...</option>
                        {paymentMethods.map(pm => (
                          <option key={pm.id} value={pm.id}>{pm.card_brand} ****{pm.card_last4}{pm.is_default ? ' (Default)' : ''}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <button onClick={async () => {
                    const amt = Number(topUpAmount);
                    if (!amt || amt <= 0) return showToast('Enter a valid amount', 'error');
                    if (paymentMethods.length > 0 && !topUpPaymentMethodId) return showToast('Select a payment method', 'error');
                    setTopUpLoading(true);
                    try {
                      const body = { amount: amt };
                      if (topUpPaymentMethodId) body.payment_method_id = Number(topUpPaymentMethodId);
                      await api.post('/host/wallet/top-up', body);
                      showToast(`Wallet topped up with R${amt.toLocaleString()}!`);
                      setTopUpAmount('');
                      setTopUpPaymentMethodId('');
                      loadWallet();
                    } catch (e) { showToast(e.response?.data?.error || 'Top-up failed', 'error'); }
                    finally { setTopUpLoading(false); }
                  }} disabled={topUpLoading || !topUpAmount || Number(topUpAmount) <= 0} style={{
                    padding: '12px 28px', borderRadius: '10px', width: '100%',
                    background: topUpLoading ? 'var(--gray)' : 'linear-gradient(135deg, #E8A0BF, #D4A853)',
                    color: '#fff', border: 'none',
                    cursor: topUpLoading || !topUpAmount ? 'not-allowed' : 'pointer',
                    fontSize: '14px', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                    opacity: topUpLoading || !topUpAmount ? 0.6 : 1
                  }}>
                    {topUpLoading ? (
                      <><div style={{ width: '14px', height: '14px', border: '2px solid rgba(255,255,255,0.3)', borderTop: '2px solid white', borderRadius: '50%', animation: 'ggrSpin 0.8s linear infinite' }} /> Processing...</>
                    ) : (
                      <><FiArrowDown size={16} /> Top Up Wallet</>
                    )}
                  </button>

                  {paymentMethods.length === 0 && (
                    <p style={{ fontSize: '11px', color: 'var(--gray)', textAlign: 'center', marginTop: '8px' }}>
                      Add a card above to enable quick top-ups. You can also top up manually without a saved card.
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* BANKING + KYC SUB-TAB */}
            {walletSubTab === 'banking' && (
              <div>
                {/* KYC Section */}
                <div style={{ marginBottom: '28px' }}>
                  <h4 style={{ fontSize: '15px', marginBottom: '4px' }}>KYC Verification</h4>
                  <p style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '16px' }}>
                    Upload a clear photo or scan of your ID document, passport, or driver's license.
                  </p>

                  {/* KYC Status Badge */}
                  {kycStatus && (
                    <div style={{
                      display: 'inline-flex', alignItems: 'center', gap: '6px',
                      padding: '6px 14px', borderRadius: '20px', marginBottom: '16px',
                      fontSize: '12px', fontWeight: 600,
                      background: kycStatus === 'approved' ? 'rgba(16,185,129,0.1)' : kycStatus === 'rejected' ? 'rgba(255,68,68,0.1)' : 'rgba(245,158,11,0.1)',
                      color: kycStatus === 'approved' ? '#10B981' : kycStatus === 'rejected' ? '#FF4444' : '#F59E0B'
                    }}>
                      {kycStatus === 'approved' ? <FiCheck size={14} /> : kycStatus === 'rejected' ? <FiX size={14} /> : <FiClock size={14} />}
                      {kycStatus === 'approved' ? 'Verified' : kycStatus === 'rejected' ? 'Rejected' : 'Pending Review'}
                    </div>
                  )}
                  {kycRejectionReason && (
                    <p style={{ fontSize: '12px', color: '#FF4444', marginTop: '-8px', marginBottom: '12px' }}>
                      Reason: {kycRejectionReason}. Please re-upload.
                    </p>
                  )}

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                    <div className="form-group">
                      <label style={{ fontSize: '13px' }}>Document Type</label>
                      <select value={kycDocType} onChange={e => setKycDocType(e.target.value)} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', background: 'var(--white)' }}>
                        <option value="id_book">ID Book</option>
                        <option value="passport">Passport</option>
                        <option value="driver_license">Driver's License</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group" style={{ marginTop: '12px' }}>
                    <label style={{ fontSize: '13px' }}>Upload Document</label>
                    {kycFile ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 12px', borderRadius: '8px', background: 'var(--cream)', fontSize: '12px' }}>
                        <FiCheck size={14} color="#10B981" />
                        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{kycFile.name}</span>
                        <button onClick={() => setKycFile(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)' }}><FiX size={14} /></button>
                      </div>
                    ) : (
                      <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '14px', borderRadius: '8px', border: '2px dashed rgba(0,0,0,0.15)', cursor: 'pointer', fontSize: '12px', color: 'var(--gray)' }}>
                        <FiUpload size={14} /> Choose file
                        <input type="file" accept="image/*" onChange={e => { if (e.target.files[0]) setKycFile(e.target.files[0]); }} style={{ display: 'none' }} />
                      </label>
                    )}
                  </div>
                  <button
                    onClick={submitKycDocuments}
                    disabled={uploadingKyc || !kycFile}
                    style={{
                      marginTop: '14px', padding: '10px 24px', borderRadius: '10px',
                      background: uploadingKyc ? 'var(--gray)' : 'var(--rose)',
                      color: 'white', border: 'none', cursor: uploadingKyc ? 'not-allowed' : 'pointer',
                      fontSize: '13px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px'
                    }}
                  >
                    {uploadingKyc ? (
                      <><div style={{ width: '14px', height: '14px', border: '2px solid rgba(255,255,255,0.3)', borderTop: '2px solid white', borderRadius: '50%', animation: 'ggrSpin 0.8s linear infinite' }} /> Uploading...</>
                    ) : (
                      <><FiUpload size={14} /> Submit for Review</>
                    )}
                  </button>
                </div>

                {/* Banking Details Section */}
                <div>
                  <h4 style={{ fontSize: '15px', marginBottom: '4px' }}>Banking Details</h4>
                  <p style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '16px' }}>
                    Add your bank account for withdrawals.
                  </p>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                    <div className="form-group">
                      <label style={{ fontSize: '13px' }}>Bank Name</label>
                      <input
                        value={bankingForm.bank_name}
                        onChange={e => setBankingForm({ ...bankingForm, bank_name: e.target.value })}
                        placeholder="e.g., FNB, Standard Bank"
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div className="form-group">
                      <label style={{ fontSize: '13px' }}>Account Holder</label>
                      <input
                        value={bankingForm.account_holder}
                        onChange={e => setBankingForm({ ...bankingForm, account_holder: e.target.value })}
                        placeholder="Your full name"
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div className="form-group">
                      <label style={{ fontSize: '13px' }}>Account Number</label>
                      <input
                        value={bankingForm.account_number}
                        onChange={e => setBankingForm({ ...bankingForm, account_number: e.target.value.replace(/\D/g, '') })}
                        placeholder="e.g., 1234567890"
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div className="form-group">
                      <label style={{ fontSize: '13px' }}>Branch Code</label>
                      <input
                        value={bankingForm.branch_code}
                        onChange={e => setBankingForm({ ...bankingForm, branch_code: e.target.value })}
                        placeholder="e.g., 250655"
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div className="form-group">
                      <label style={{ fontSize: '13px' }}>Account Type</label>
                      <select
                        value={bankingForm.account_type}
                        onChange={e => setBankingForm({ ...bankingForm, account_type: e.target.value })}
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', background: 'var(--white)' }}
                      >
                        <option value="cheque">Cheque / Current</option>
                        <option value="savings">Savings</option>
                        <option value="transmission">Transmission</option>
                      </select>
                    </div>
                  </div>
                  <button
                    onClick={async () => {
                      if (!bankingForm.bank_name || !bankingForm.account_holder || !bankingForm.account_number) return;
                      try {
                        await api.post('/host/banking', bankingForm);
                        showToast('Banking details saved!');
                        loadWallet();
                      } catch (e) {
                        showToast(e.response?.data?.error || 'Failed to save banking details', 'error');
                      }
                    }}
                    style={{
                      marginTop: '14px', padding: '10px 24px', borderRadius: '10px',
                      background: 'var(--dark)', color: 'white', border: 'none',
                      cursor: (!bankingForm.bank_name || !bankingForm.account_holder || !bankingForm.account_number) ? 'not-allowed' : 'pointer',
                      fontSize: '13px', fontWeight: 600, opacity: (!bankingForm.bank_name || !bankingForm.account_holder || !bankingForm.account_number) ? 0.5 : 1
                    }}
                    disabled={!bankingForm.bank_name || !bankingForm.account_holder || !bankingForm.account_number}
                  >
                    <FiCreditCard size={14} style={{ marginRight: '6px' }} /> Save Banking Details
                  </button>
                  {hostBanking && (
                    <div style={{ marginTop: '12px', padding: '10px 14px', borderRadius: '8px', background: 'rgba(16,185,129,0.06)', fontSize: '12px', color: '#10B981', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <FiCheck size={14} /> Banking details on file: {hostBanking.bank_name} — {hostBanking.account_holder}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* WITHDRAW SUB-TAB */}
            {walletSubTab === 'withdraw' && (
              <div>
                <h4 style={{ fontSize: '15px', marginBottom: '4px' }}>Withdraw Funds</h4>
                <p style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '16px' }}>
                  Transfer your available balance to your bank account.
                </p>

                {hostBanking?.kyc_status !== 'approved' ? (
                  <div style={{
                    padding: '20px', borderRadius: '12px', textAlign: 'center',
                    background: 'rgba(245,158,11,0.06)', border: '1px solid rgba(245,158,11,0.15)'
                  }}>
                    <FiClock size={32} color="#F59E0B" style={{ marginBottom: '8px' }} />
                    <p style={{ fontSize: '13px', color: '#92400E', margin: '0 0 4px', fontWeight: 600 }}>
                      KYC Verification Required
                    </p>
                    <p style={{ fontSize: '12px', color: '#92400E', margin: '0 0 12px' }}>
                      Please complete KYC verification in the Banking + KYC tab before withdrawing.
                    </p>
                    <button
                      onClick={() => setWalletSubTab('banking')}
                      style={{
                        padding: '8px 18px', borderRadius: '8px', background: '#F59E0B', color: 'white',
                        border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 600
                      }}
                    >
                      Go to Banking + KYC
                    </button>
                  </div>
                ) : !hostBanking?.bank_name ? (
                  <div style={{
                    padding: '20px', borderRadius: '12px', textAlign: 'center',
                    background: 'rgba(59,130,246,0.06)', border: '1px solid rgba(59,130,246,0.15)'
                  }}>
                    <FiCreditCard size={32} color="#3B82F6" style={{ marginBottom: '8px' }} />
                    <p style={{ fontSize: '13px', color: '#1E40AF', margin: '0 0 4px', fontWeight: 600 }}>
                      Banking Details Required
                    </p>
                    <p style={{ fontSize: '12px', color: '#1E40AF', margin: '0 0 12px' }}>
                      Please add your banking details before withdrawing.
                    </p>
                    <button
                      onClick={() => setWalletSubTab('banking')}
                      style={{
                        padding: '8px 18px', borderRadius: '8px', background: '#3B82F6', color: 'white',
                        border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 600
                      }}
                    >
                      Go to Banking Details
                    </button>
                  </div>
                ) : (
                  <div>
                    <div style={{
                      padding: '16px', borderRadius: '12px', background: 'var(--cream)',
                      marginBottom: '20px', textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '11px', color: 'var(--gray)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Available Balance</div>
                      <div style={{ fontSize: '28px', fontWeight: 700, color: 'var(--dark)' }}>
                        R{Number(hostWallet?.available_balance || 0).toLocaleString()}
                      </div>
                    </div>

                    <div style={{ display: 'flex', gap: '10px' }}>
                      <div className="form-group" style={{ flex: 1 }}>
                        <label style={{ fontSize: '13px' }}>Amount (R)</label>
                        <input
                          type="number"
                          value={withdrawAmount}
                          onChange={e => setWithdrawAmount(e.target.value)}
                          placeholder="Enter amount"
                          min="1"
                          max={hostWallet?.available_balance || 0}
                          style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', boxSizing: 'border-box' }}
                        />
                      </div>
                    </div>
                    <p style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '6px' }}>
                      Withdrawing to: {hostBanking.bank_name} — ...{hostBanking.account_number?.slice(-4) || '****'}
                    </p>
                    <button
                      onClick={async () => {
                        const amt = Number(withdrawAmount);
                        if (!amt || amt <= 0) return;
                        if (amt > (hostWallet?.available_balance || 0)) {
                          showToast('Insufficient balance', 'error');
                          return;
                        }
                        try {
                          await api.post('/host/wallet/withdraw', { amount: amt });
                          showToast(`R${amt} withdrawal requested!`);
                          setWithdrawAmount('');
                          loadWallet();
                        } catch (e) {
                          showToast(e.response?.data?.error || 'Withdrawal failed', 'error');
                        }
                      }}
                      disabled={!withdrawAmount || Number(withdrawAmount) <= 0 || Number(withdrawAmount) > (hostWallet?.available_balance || 0)}
                      style={{
                        marginTop: '14px', padding: '12px 32px', borderRadius: '10px',
                        background: 'var(--rose)', color: 'white', border: 'none',
                        cursor: (!withdrawAmount || Number(withdrawAmount) <= 0) ? 'not-allowed' : 'pointer',
                        fontSize: '14px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '8px',
                        opacity: (!withdrawAmount || Number(withdrawAmount) <= 0) ? 0.5 : 1
                      }}
                    >
                      <FiArrowUpCircle size={16} /> Withdraw Funds
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        )}

        {/* Events */}
        <h3 style={{ fontSize: '20px', marginBottom: '16px' }}>My Events</h3>
        {loading ? (
          <div className="card" style={{ textAlign: 'center', padding: '60px 40px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
            <img src="/ggr-loading-logo.png" alt="Loading" style={{ width: '90px', height: '90px', animation: 'ggrZoom 1.6s ease-in-out infinite', objectFit: 'contain' }} />
            <style>{`@keyframes ggrZoom { 0%, 100% { transform: scale(0.88); } 50% { transform: scale(1.10); } }`}</style>
            <p style={{ color: 'var(--gray)', fontSize: '14px', fontWeight: 500 }}>Loading events...</p>
          </div>
        ) : events.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎉</div>
            <h3 style={{ marginBottom: '8px' }}>No Events Yet</h3>
            <p style={{ color: 'var(--gray)', marginBottom: '24px' }}>Create your first celebration to get started</p>
            <button className="btn btn-primary" onClick={() => { setShowCreate(true); setCreateStep(1); }}><FiPlus /> Create Event</button>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
            {events.map((event, i) => {
              return (
              <div key={event.id} className={`card card-enter card-stagger-${(i % 12) + 1}`} style={{ padding: 0, overflow: 'hidden', position: 'relative' }}>
                <div style={{ height: '140px', background: (event.cover_image || getDefaultBanner(event.event_type)) ? `url(${event.cover_image || getDefaultBanner(event.event_type)}) center/cover` : 'linear-gradient(135deg, var(--rose), var(--rose-deep))', display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', padding: '12px 16px' }}>
                  <span className="tag" style={{ background: 'rgba(255,255,255,0.9)', color: '#1c1c1e' }}>{event.event_type}</span>
                  {/* Activity badges on cover image */}
                  <div style={{ display: 'flex', gap: '6px' }}>
                    {/* Chat quick-access — only when conversations exist for this event */}
                    {(event.unread_chat_conversations > 0 || event.last_chat_preview) && (
                    <button onClick={(e) => { e.preventDefault(); navigate(`/event/${event.id}?tab=vendors`); }}
                      title={`${event.unread_chat_conversations || 0} conversation${event.unread_chat_conversations !== 1 ? 's' : ''} with unread messages`}
                      style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 8px', borderRadius: '12px', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: 600, backdropFilter: 'blur(4px)', position: 'relative' }}>
                      <FiMessageCircle size={12} />
                      {event.unread_chat_count > 0 && (
                        <span style={{ background: 'var(--rose)', borderRadius: '50%', width: '18px', height: '18px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', position: 'absolute', top: '-6px', right: '-6px', fontWeight: 700, flexShrink: 0 }}>{event.unread_chat_count}</span>
                      )}
                    </button>
                    )}
                    {/* New RSVP badge — only when there are new ones */}
                    {event.new_rsvp_count > 0 && (
                      <button onClick={(e) => { e.preventDefault(); markRsvpsViewed(event.id); navigate(`/event/${event.id}?tab=guests`); }}
                        title={`${event.new_rsvp_count} new RSVP${event.new_rsvp_count > 1 ? 's' : ''}`}
                        style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 8px', borderRadius: '12px', background: 'var(--rose)', color: 'white', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: 600, animation: 'rsvpPulse 1.2s ease-in-out infinite' }}>
                        <FiUsers size={12} />
                        <span>{event.new_rsvp_count}</span>
                      </button>
                    )}
                    {/* Pay Now — when bookings are confirmed but unpaid */}
                    {event.pending_payment_count > 0 && (
                    <button onClick={(e) => { e.preventDefault(); navigate(`/event/${event.id}?tab=bookings`); }}
                      title={`${event.pending_payment_count} booking${event.pending_payment_count > 1 ? 's' : ''} ready for payment`}
                      style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 8px', borderRadius: '12px', background: '#10B981', color: 'white', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: 600, animation: 'rsvpPulse 1.2s ease-in-out infinite' }}>
                      <CoinIcon size={12} />
                      <span>Pay</span>
                    </button>
                    )}
                    {/* Paid bookings badge */}
                    {event.paid_booking_count > 0 && (
                    <button onClick={(e) => { e.preventDefault(); navigate(`/event/${event.id}?tab=bookings`); }}
                      title={`${event.paid_booking_count} booking${event.paid_booking_count > 1 ? 's' : ''} confirmed & paid`}
                      style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 8px', borderRadius: '12px', background: '#059669', color: 'white', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}>
                      <FiCheckCircle size={12} />
                      <span>{event.paid_booking_count}</span>
                    </button>
                    )}
                    {/* Reschedule alerts — when vendor bookings have pending reschedule requests */}
                    {event.pending_reschedule_count > 0 && (
                    <button onClick={(e) => { e.preventDefault(); navigate(`/event/${event.id}?tab=bookings`); }}
                      title={`${event.pending_reschedule_count} booking${event.pending_reschedule_count > 1 ? 's' : ''} with reschedule request${event.pending_reschedule_count > 1 ? 's' : ''}`}
                      style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 8px', borderRadius: '12px', background: '#F59E0B', color: 'white', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}>
                      <FiCalendar size={12} />
                      <span>{event.pending_reschedule_count}</span>
                    </button>
                    )}
                    {/* New gift contributions badge */}
                    {event.new_gift_contributions > 0 && (
                    <button onClick={(e) => { e.preventDefault(); navigate(`/event/${event.id}?tab=registry`); }}
                      title={`${event.new_gift_contributions} new gift contribution${event.new_gift_contributions > 1 ? 's' : ''}`}
                      style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 8px', borderRadius: '12px', background: '#EC4899', color: 'white', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: 600, animation: 'rsvpPulse 1.2s ease-in-out infinite' }}>
                      <FiGift size={12} />
                      <span>{event.new_gift_contributions}</span>
                    </button>
                    )}
                    {/* New ticket sales badge */}
                    {event.new_ticket_sales > 0 && (
                    <button onClick={(e) => { e.preventDefault(); markTicketsViewed(event.id); navigate(`/event/${event.id}?tab=tickets`); }}
                      title={`${event.new_ticket_sales} new ticket sale${event.new_ticket_sales > 1 ? 's' : ''}`}
                      style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 8px', borderRadius: '12px', background: '#8B5CF6', color: 'white', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: 600, animation: 'rsvpPulse 1.2s ease-in-out infinite' }}>
                      <IoTicketOutline size={13} />
                      <span>{event.new_ticket_sales}</span>
                    </button>
                    )}
                    {/* Deliveries quick-access — only when event has vendor bookings */}
                    {event.vendor_booking_count > 0 && (
                    <button onClick={(e) => { e.preventDefault(); navigate(`/event/${event.id}?tab=deliveries`); }}
                      title="Track deliveries"
                      style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 8px', borderRadius: '12px', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: 600, backdropFilter: 'blur(4px)', position: 'relative' }}>
                      <FiTruck size={12} />
                      {event.active_deliveries > 0 && (
                        <span style={{ background: '#3B82F6', borderRadius: '50%', width: '18px', height: '18px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', position: 'absolute', top: '-6px', right: '-6px', fontWeight: 700, flexShrink: 0 }}>{event.active_deliveries}</span>
                      )}
                    </button>
                    )}
                  </div>
                </div>
                <div style={{ padding: '16px 20px 20px' }}>
                  <h3 style={{ fontSize: '17px', marginBottom: '8px' }}>{event.title}</h3>
                  {/* Chat preview snippet — only when conversations exist */}
                  {event.last_chat_preview && event.unread_chat_count > 0 && (
                    <div onClick={() => navigate(`/event/${event.id}?tab=vendors`)}
                      style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '10px', cursor: 'pointer', padding: '8px 10px', borderRadius: '8px', background: 'var(--cream)', display: 'flex', alignItems: 'center', gap: '6px', lineHeight: 1.3, maxHeight: '32px', overflow: 'hidden' }}>
                      <FiMessageCircle size={12} style={{ flexShrink: 0, color: 'var(--rose)' }} />
                      <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{event.last_chat_preview}</span>
                    </div>
                  )}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginBottom: '14px', fontSize: '13px', color: 'var(--gray)' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><FiCalendar size={13} /> {event.event_date ? new Date(event.event_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'long', year: 'numeric' }) : 'Date TBD'}</span>
                    {event.location ? (
                      <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(event.location)}`} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'var(--gray)', textDecoration: 'underline', textDecorationStyle: 'dotted', textUnderlineOffset: '3px' }}><FiMapPin size={13} /> {event.location}</a>
                    ) : (
                      <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><FiMapPin size={13} /> Location TBD</span>
                    )}
                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><FiUsers size={13} /> {event.guest_count || event.estimated_guests || 0} Guests</span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><CoinIcon size={13} /> Budget R{Number(event.budget || 0).toLocaleString()}</span>
                  </div>
                  {event.tasks_total > 0 && (
                    <div style={{ marginBottom: '14px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', marginBottom: '4px' }}>
                        <span style={{ color: 'var(--gray)' }}>Tasks</span>
                        <span style={{ fontWeight: 600 }}>{event.tasks_done}/{event.tasks_total}</span>
                      </div>
                      <div className="progress-bar">
                        <div className="progress-fill" style={{ width: `${(event.tasks_done/event.tasks_total)*100}%` }}></div>
                      </div>
                    </div>
                  )}
                  <Link to={`/event/${event.id}`} className="btn btn-primary btn-full btn-sm">Open Event Workspace</Link>
                </div>
              </div>
            )})}
          </div>
        )}
      </div>

      {/* Create Event Modal */}
      {showCreate && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowCreate(false)}>
          <div className="modal" style={{ maxWidth: '550px', paddingBottom: isMobile ? '80px' : undefined }}>
            {createStep === 1 ? (
              <>
                <h2>Choose Celebration Type</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                  {EVENT_TYPES.map(type => (
                    <button key={type} className={`btn ${newEvent.event_type === type ? 'btn-primary' : 'btn-secondary'} btn-sm`} onClick={() => setNewEvent({...newEvent, event_type: type})} style={{ justifyContent: 'center' }}>
                      {type}
                    </button>
                  ))}
                </div>
                {newEvent.event_type === 'Custom Event' && (
                  <div className="form-group" style={{ marginTop: '16px' }}>
                    <label>Your Event Type</label>
                    <input value={customType} onChange={e => setCustomType(e.target.value)} placeholder="Enter your celebration type" />
                  </div>
                )}
                <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                  <button className="btn btn-secondary btn-full" onClick={() => setShowCreate(false)}>Cancel</button>
                  <button className="btn btn-primary btn-full" onClick={() => setCreateStep(2)} disabled={!newEvent.event_type || (newEvent.event_type === 'Custom Event' && !customType)}>Next</button>
                </div>
              </>
            ) : (
              <>
                <h2>Event Details</h2>
                <span className="tag tag-gold" style={{ marginBottom: '16px', display: 'inline-block' }}>
                  {newEvent.event_type === 'Custom Event' ? customType : newEvent.event_type}
                </span>
                <div className="form-group">
                  <label>Event Title</label>
                  <input value={newEvent.title} onChange={e => setNewEvent({...newEvent, title: e.target.value})} placeholder={
                    ({
                      'Wedding': "e.g., Thabo & Lerato's Wedding",
                      'Lobola': "e.g., The Mokoena-Dlamini Lobola Ceremony",
                      'Umembeso': "e.g., Nomsa's Umembeso Celebration",
                      'Birthday': "e.g., Lesego's 40th Birthday Bash",
                      'Kids Party': "e.g., Little Amara's 5th Birthday Party",
                      'Graduation': "e.g., Sipho's BCom Graduation Celebration",
                      'Gender Reveal': "e.g., Baby Molefe — Pink or Blue?",
                      'Engagement': "e.g., Kabelo & Palesa's Engagement Party",
                      'Memorial / Unveiling': "e.g., In Loving Memory of Mama Grace",
                      'Funeral': "e.g., Farewell Service for Ntate Modise",
                      'Matric Dance': "e.g., Class of 2026 Matric Dance",
                      'Corporate Event': "e.g., GGR Annual Launch Event 2026",
                      'Custom Event': "e.g., Sarah's Baby Shower",
                    })[newEvent.event_type] || "e.g., Lesego's 40th Birthday"
                  } required />
                  <div style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '4px' }}>
                    {({
                      'Wedding': 'Tip: Include both names — "Thabo & Lerato\'s Wedding"',
                      'Lobola': 'Tip: Include both family names — "The Mokoena-Dlamini Lobola"',
                      'Umembeso': 'Tip: Use the bride\'s name — "Nomsa\'s Umembeso"',
                      'Birthday': 'Tip: Add the age — "Lesego\'s 40th Birthday Bash"',
                      'Kids Party': 'Tip: Make it fun — "Little Amara\'s Unicorn Party"',
                      'Graduation': 'Tip: Include the qualification — "Sipho\'s BCom Graduation"',
                      'Gender Reveal': 'Tip: Keep it playful — "Baby Molefe — Pink or Blue?"',
                      'Engagement': 'Tip: Include the couple — "Kabelo & Palesa Get Engaged!"',
                      'Memorial / Unveiling': 'Tip: Honour the person — "In Loving Memory of Mama Grace"',
                      'Funeral': 'Tip: Keep it respectful — "Farewell Service for Ntate Modise"',
                      'Matric Dance': 'Tip: Include the year — "Class of 2026 Matric Dance"',
                      'Corporate Event': 'Tip: Include your company — "GGR Annual Launch 2026"',
                      'Custom Event': 'Tip: Be descriptive — "Sarah\'s Baby Shower" or "Family Reunion 2026"',
                    })[newEvent.event_type] || ''}
                  </div>
                </div>
                <div className="form-group">
                  <label>Event Date</label>
                  <input type="date" value={newEvent.event_date} onChange={e => setNewEvent({...newEvent, event_date: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Event Time</label>
                  <select value={newEvent.event_time || ''} onChange={e => setNewEvent({...newEvent, event_time: e.target.value})}>
                    <option value="">Select a time frame</option>
                    <option value="08:00 - 12:00">Morning Session (08:00 – 12:00)</option>
                    <option value="09:00 - 17:00">Full Day (09:00 – 17:00)</option>
                    <option value="10:00 - 18:00">Full Day (10:00 – 18:00)</option>
                    <option value="17:00 - Till Late">Evening (17:00 – Till Late)</option>
                    <option value="18:00 - Till Late">Evening (18:00 – Till Late)</option>
                    <option value="19:00 - Till Late">Night (19:00 – Till Late)</option>
                    <option value="20:00 - Till Late">Late Night (20:00 – Till Late)</option>
                    <option value="custom">Custom Time Frame</option>
                  </select>
                  {newEvent.event_time === 'custom' && (
                    <input value={newEvent.custom_time || ''} onChange={e => setNewEvent({...newEvent, custom_time: e.target.value})}
                      placeholder="e.g., 06:00 PM - 11:00 PM" style={{ marginTop: '8px' }} />
                  )}
                </div>
                <div className="form-group">
                  <label>Location</label>
                  <input value={newEvent.location} onChange={e => setNewEvent({...newEvent, location: e.target.value})} placeholder="e.g., Pretoria, Gauteng" />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div className="form-group">
                    <label>Estimated Guests</label>
                    <input type="number" value={newEvent.estimated_guests} onChange={e => setNewEvent({...newEvent, estimated_guests: e.target.value})} placeholder="120" />
                  </div>
                  <div className="form-group">
                    <label>Budget (R)</label>
                    <input type="number" value={newEvent.budget} onChange={e => setNewEvent({...newEvent, budget: e.target.value})} placeholder="50000" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea value={newEvent.description} onChange={e => setNewEvent({...newEvent, description: e.target.value})} rows={3} placeholder="Describe your event..." />
                </div>
                <div className="form-group">
                  <label>Dress Code</label>
                  <select value={['Formal / Black Tie','Semi-Formal','Smart Casual','Casual','Traditional / Cultural Attire','All White','All Black','Cocktail Attire','Garden Party','Themed'].includes(newEvent.dress_code) ? newEvent.dress_code : newEvent.dress_code ? 'custom' : ''} onChange={e => setNewEvent({...newEvent, dress_code: e.target.value === 'custom' ? (newEvent.dress_code && !['Formal / Black Tie','Semi-Formal','Smart Casual','Casual','Traditional / Cultural Attire','All White','All Black','Cocktail Attire','Garden Party','Themed'].includes(newEvent.dress_code) ? newEvent.dress_code : '') : e.target.value})}>
                    <option value="">No dress code</option>
                    <option value="Formal / Black Tie">Formal / Black Tie</option>
                    <option value="Semi-Formal">Semi-Formal</option>
                    <option value="Smart Casual">Smart Casual</option>
                    <option value="Casual">Casual</option>
                    <option value="Traditional / Cultural Attire">Traditional / Cultural Attire</option>
                    <option value="All White">All White</option>
                    <option value="All Black">All Black</option>
                    <option value="Cocktail Attire">Cocktail Attire</option>
                    <option value="Garden Party">Garden Party</option>
                    <option value="Themed">Themed</option>
                    <option value="custom">Custom...</option>
                  </select>
                  {(newEvent.dress_code && !['','Formal / Black Tie','Semi-Formal','Smart Casual','Casual','Traditional / Cultural Attire','All White','All Black','Cocktail Attire','Garden Party','Themed'].includes(newEvent.dress_code)) && (
                    <input value={newEvent.dress_code} onChange={e => setNewEvent({...newEvent, dress_code: e.target.value})} placeholder="e.g., Red and Gold, African Print..." style={{ marginTop: '8px' }} />
                  )}
                </div>
                <div className="form-group">
                  <label>Event Theme Colors</label>
                  <input value={newEvent.theme_color || ''} onChange={e => setNewEvent({...newEvent, theme_color: e.target.value})} placeholder="e.g., Gold and Rose Pink, Navy Blue and Silver..." />
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '8px' }}>
                    {['Gold & White','Black & Gold','Rose Pink & Gold','Navy Blue & Silver','Burgundy & Gold','All White','Green & Gold','Purple & Silver','Red & Black','Emerald & Cream'].map(t => (
                      <button type="button" key={t} onClick={() => setNewEvent({...newEvent, theme_color: t})} style={{ padding: '5px 12px', borderRadius: '20px', fontSize: '12px', background: newEvent.theme_color === t ? 'var(--dark)' : 'var(--gray-light)', color: newEvent.theme_color === t ? 'white' : 'var(--gray)', border: 'none', cursor: 'pointer', fontWeight: 500, transition: 'all 0.2s' }}>{t}</button>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label>Cover Image</label>
                  {newEvent.coverFile && (
                    <div style={{ position: 'relative', marginBottom: '10px' }}>
                      <img src={URL.createObjectURL(newEvent.coverFile)} alt="Cover preview" style={{ width: '100%', height: '140px', objectFit: 'cover', borderRadius: '8px' }} />
                      <button onClick={() => setNewEvent({...newEvent, coverFile: null})} style={{ position: 'absolute', top: '8px', right: '8px', background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: '50%', width: '36px', height: '36px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiX size={18} /></button>
                    </div>
                  )}
                  <input type="file" accept="image/*" onChange={e => { if (e.target.files[0]) setCropperImage({ src: URL.createObjectURL(e.target.files[0]), aspect: 16/9, title: 'Crop Cover Image' }); }} style={{ padding: '10px' }} />
                </div>
                <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                  <button className="btn btn-secondary btn-full" onClick={() => setCreateStep(1)}>Back</button>
                  <button className="btn btn-primary btn-full" onClick={createEvent} disabled={!newEvent.title}>Create Event</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* WhatsApp-style notification toast */}
      {notifToast && (
        <div
          onClick={() => { if (notifToast.link) { navigate(notifToast.link); setNotifToast(null); } }}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 250,
            background: 'var(--white)', boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
            padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: '12px',
            transform: notifToastExiting ? 'translateY(-100%)' : 'translateY(0)',
            transition: 'transform 0.3s ease',
            cursor: notifToast.link ? 'pointer' : 'default',
          }}
        >
          <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'var(--rose)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <FiBell size={16} color="#fff" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '2px' }}>{notifToast.title}</div>
            <div style={{ fontSize: '13px', color: 'var(--gray)', lineHeight: 1.4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{notifToast.message}</div>
          </div>
          <button
            onClick={(e) => { e.stopPropagation(); setNotifToastExiting(true); setTimeout(() => { setNotifToast(null); setNotifToastExiting(false); }, 300); }}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)', padding: '4px', flexShrink: 0 }}
          >
            <FiX size={16} />
          </button>
        </div>
      )}

      {/* Notifications Drawer */}
      {showNotifs && (
        <>
          <div onClick={() => setShowNotifs(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 199 }} />
          <div className="notif-drawer" style={{ position: 'fixed', top: 0, right: 0, bottom: 0, width: isMobile ? '85vw' : '400px', maxWidth: '100vw', background: 'var(--white)', boxShadow: '-4px 0 20px rgba(0,0,0,0.1)', zIndex: 200, display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--cream-dark)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
              <button onClick={() => setShowNotifs(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--dark)', padding: '4px', display: 'flex' }}><FiArrowLeft size={20} /></button>
              <h3 style={{ fontSize: '16px', margin: 0, flex: 1, textAlign: 'center' }}>Notifications</h3>
              <button onClick={() => markNotificationsRead()} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--rose)', fontSize: '12px', fontWeight: 600, padding: '4px 6px', whiteSpace: 'nowrap' }}>Mark all read</button>
            </div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {notifications.length === 0 ? (
              <div style={{ padding: '40px 20px', textAlign: 'center', color: 'var(--gray)', fontSize: '14px' }}>No notifications yet.</div>
            ) : notifications.map(n => (
              <div key={n.id} onClick={() => { markNotificationRead(n.id); if (n.link) { navigate(n.link); setShowNotifs(false); } }} style={{ padding: '14px 20px', borderBottom: '1px solid var(--cream)', borderLeft: n.read ? 'none' : '3px solid #E3425C', cursor: n.link ? 'pointer' : 'default' }}>
                <div style={{ fontWeight: n.read ? 400 : 600, fontSize: '14px', marginBottom: '4px' }}>{n.title}</div>
                <div style={{ fontSize: '13px', color: 'var(--gray)', lineHeight: 1.5 }}>{n.message}</div>
                <div style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '6px' }}>{new Date(n.created_at).toLocaleString('en-ZA')}</div>
              </div>
            ))}
          </div>
        </div>
        </>
      )}

      {/* Settings Modal — vertical list layout */}
      {showSettings && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowSettings(false)}>
          <div className="modal" style={{ maxWidth: '480px', padding: 0, maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '16px 20px', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
              {settingsTab ? (
                <button onClick={() => setSettingsTab('')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--dark)', padding: '4px', display: 'flex' }}>
                  <FiArrowLeft size={20} />
                </button>
              ) : (
                <div style={{ width: '28px' }} />
              )}
              <h3 style={{ fontSize: '18px', margin: 0, flex: 1 }}>
                {settingsTab === 'profile' ? 'Profile' :
                 settingsTab === 'password' ? 'Change Password' :
                 settingsTab === 'notifications' ? 'Notifications' :
                 settingsTab === 'feedback' ? 'Feedback' :
                 settingsTab === 'support' ? 'Contact Support' :
                 settingsTab === 'danger' ? 'Deactivate Account' :
                 'Settings'}
              </h3>
              <button onClick={() => { setShowSettings(false); setSettingsTab(''); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)', padding: '4px', display: 'flex' }}>
                <FiX size={20} />
              </button>
            </div>

            {/* Content area */}
            <div style={{ flex: 1, overflowY: 'auto', padding: settingsTab ? '20px' : '0' }}>

              {/* ── Main list ── */}
              {!settingsTab && (
                <div style={{ padding: '8px 0' }}>
                  {/* Profile row */}
                  <button onClick={() => { setSettingsTab('profile'); }} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '14px 20px', width: '100%', border: 'none', background: 'transparent', cursor: 'pointer', fontFamily: 'Inter, sans-serif', borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'var(--rose)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '18px', fontWeight: 700, flexShrink: 0 }}>
                      {(user?.name || 'U')[0].toUpperCase()}
                    </div>
                    <div style={{ flex: 1, textAlign: 'left' }}>
                      <div style={{ fontSize: '15px', fontWeight: 500, color: 'var(--dark)' }}>{user?.name || 'User'}</div>
                      <div style={{ fontSize: '12px', color: 'var(--gray)' }}>{user?.email || ''}</div>
                    </div>
                    <FiChevronRight size={18} color="var(--gray)" />
                  </button>

                  {/* Password */}
                  <SettingsRow icon={<FiLock size={18} />} iconBg="rgba(59,130,246,0.1)" iconColor="#3B82F6" label="Password" onClick={() => setSettingsTab('password')} />

                  {/* Notifications */}
                  <SettingsRow icon={<FiBell size={18} />} iconBg="rgba(245,158,11,0.1)" iconColor="#F59E0B" label="Notifications" onClick={() => setSettingsTab('notifications')} />

                  {/* Feedback */}
                  <SettingsRow icon={<FiMessageSquare size={18} />} iconBg="rgba(16,185,129,0.1)" iconColor="#10B981" label="Feedback" onClick={() => setSettingsTab('feedback')} />

                  {/* Support */}
                  <SettingsRow icon={<FiHelpCircle size={18} />} iconBg="rgba(139,92,246,0.1)" iconColor="#8B5CF6" label="Support" onClick={() => setSettingsTab('support')} isLast />

                  {/* Danger zone */}
                  <div style={{ padding: '24px 20px 8px' }}>
                    <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', color: 'var(--gray)', marginBottom: '8px' }}>Account</div>
                    <SettingsRow icon={<FiAlertCircle size={18} />} iconBg="rgba(220,38,38,0.1)" iconColor="#DC2626" label="Deactivate Account" onClick={() => setSettingsTab('danger')} danger isLast />
                  </div>
                </div>
              )}

              {/* ── Profile sub-view ── */}
              {settingsTab === 'profile' && (
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px', padding: '16px', background: 'var(--cream)', borderRadius: '12px' }}>
                    <div onClick={() => avatarRef.current?.click()} style={{ position: 'relative', cursor: 'pointer', width: '56px', height: '56px', borderRadius: '50%', background: user?.avatar ? 'transparent' : 'var(--rose)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '22px', fontWeight: 700, overflow: 'hidden', flexShrink: 0 }}>
                      {user?.avatar ? <img src={user.avatar} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (user?.name || 'U').charAt(0).toUpperCase()}
                      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '18px', background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiUpload size={10} color="#fff" /></div>
                    </div>
                    <input type="file" ref={avatarRef} accept="image/*" onChange={handleAvatarUpload} style={{ display: 'none' }} />
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '16px' }}>{user?.name}</div>
                      <div style={{ fontSize: '13px', color: 'var(--gray)', display: 'flex', alignItems: 'center', gap: '4px' }}><FiMail size={12} /> {user?.email}</div>
                      <span className="tag" style={{ marginTop: '4px', display: 'inline-block', fontSize: '11px', background: user?.role === 'admin' ? '#7C3AED' : 'var(--rose)', color: 'white' }}>{user?.role}</span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Display Name</label>
                    <input value={profileForm.name} onChange={e => setProfileForm({ name: e.target.value })} placeholder="Your name" />
                  </div>
                  <div className="form-group">
                    <label>Email</label>
                    <input value={user?.email || ''} disabled style={{ opacity: 0.6, cursor: 'not-allowed' }} />
                    <small style={{ color: 'var(--gray)', fontSize: '12px' }}>Email cannot be changed</small>
                  </div>
                  <button className="btn btn-primary" onClick={updateName} disabled={!profileForm.name.trim()}><FiCheck size={16} /> Save Changes</button>
                </div>
              )}

              {/* ── Password sub-view ── */}
              {settingsTab === 'password' && (
                <div>
                  <div className="form-group">
                    <label>Current Password</label>
                    <input type="password" value={passwordForm.current} onChange={e => setPasswordForm({ ...passwordForm, current: e.target.value })} placeholder="Enter current password" />
                  </div>
                  <div className="form-group">
                    <label>New Password</label>
                    <input type="password" value={passwordForm.new_password} onChange={e => setPasswordForm({ ...passwordForm, new_password: e.target.value })} placeholder="At least 6 characters" />
                  </div>
                  <div className="form-group">
                    <label>Confirm New Password</label>
                    <input type="password" value={passwordForm.confirm} onChange={e => setPasswordForm({ ...passwordForm, confirm: e.target.value })} placeholder="Repeat new password" />
                  </div>
                  <button className="btn btn-primary" onClick={changePassword} disabled={!passwordForm.current || !passwordForm.new_password}><FiLock size={16} /> Change Password</button>
                </div>
              )}

              {/* ── Notifications sub-view ── */}
              {settingsTab === 'notifications' && (
                <div>
                  {/* Push Notifications */}
                  {pushSupported ? (
                    <div style={{ marginBottom: '24px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                        <div>
                          <div style={{ fontSize: '15px', fontWeight: 500, color: 'var(--dark)' }}>Push Notifications</div>
                          <div style={{ fontSize: '13px', color: 'var(--gray)', marginTop: '2px' }}>
                            {pushPermission === 'denied'
                              ? 'Blocked in browser settings. Enable in site settings to receive notifications.'
                              : pushEnabled
                                ? 'Receive notifications even when the app is closed'
                                : 'Get notified about bookings, messages, and updates'}
                          </div>
                        </div>
                        {pushPermission === 'denied' ? (
                          <div style={{ fontSize: '11px', color: '#DC2626', fontWeight: 600, background: 'rgba(220,38,38,0.08)', padding: '6px 10px', borderRadius: '6px' }}>Blocked</div>
                        ) : (
                          <button
                            onClick={async () => {
                              const next = !pushEnabled;
                              setPushEnabled(next);
                              localStorage.setItem('ggr_push', next ? 'on' : 'off');
                              if (next) {
                                await subscribeToPush();
                              } else {
                                await unsubscribeFromPush();
                              }
                            }}
                            style={{
                              width: '48px', height: '28px', borderRadius: '14px', border: 'none',
                              background: pushEnabled ? '#E3425C' : 'rgba(0,0,0,0.15)',
                              cursor: 'pointer', position: 'relative', transition: 'background 0.2s',
                              flexShrink: 0,
                            }}
                          >
                            <span style={{
                              position: 'absolute', top: '3px', left: pushEnabled ? '23px' : '3px',
                              width: '22px', height: '22px', borderRadius: '50%', background: '#fff',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.2)', transition: 'left 0.2s',
                            }} />
                          </button>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div style={{ marginBottom: '24px', padding: '12px 16px', borderRadius: '10px', background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.15)' }}>
                      <div style={{ fontSize: '13px', color: '#92400E', lineHeight: 1.5 }}>
                        Push notifications are not supported on this browser. Install the app or use Chrome/Edge for push notifications that work even when the app is closed.
                      </div>
                    </div>
                  )}

                  {/* Sound Alerts */}
                  <div style={{ marginBottom: '24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                      <div>
                        <div style={{ fontSize: '15px', fontWeight: 500, color: 'var(--dark)' }}>Notification Sound</div>
                        <div style={{ fontSize: '13px', color: 'var(--gray)', marginTop: '2px' }}>Play a sound when new notifications arrive</div>
                      </div>
                      <button
                        onClick={() => {
                          const current = localStorage.getItem('ggr_sound');
                          const next = current === 'off' ? 'on' : 'off';
                          localStorage.setItem('ggr_sound', next);
                          setSoundOn(next !== 'off');
                        }}
                        style={{
                          width: '48px', height: '28px', borderRadius: '14px', border: 'none',
                          background: soundOn ? '#E3425C' : 'rgba(0,0,0,0.15)',
                          cursor: 'pointer', position: 'relative', transition: 'background 0.2s',
                          flexShrink: 0,
                        }}
                      >
                        <span style={{
                          position: 'absolute', top: '3px', left: soundOn ? '23px' : '3px',
                          width: '22px', height: '22px', borderRadius: '50%', background: '#fff',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.2)', transition: 'left 0.2s',
                        }} />
                      </button>
                    </div>
                  </div>

                  {/* Info */}
                  <div style={{ padding: '16px', borderRadius: '12px', background: 'var(--cream)' }}>
                    <p style={{ fontSize: '13px', color: 'var(--gray)', margin: 0, lineHeight: 1.6 }}>
                      {pushEnabled && pushPermission === 'granted'
                        ? 'You\'ll receive push notifications even when the app is closed. Notifications also appear as a badge on the bell icon in the app.'
                        : 'Notifications appear as a badge count on the bell icon in the app header. Enable push notifications above to receive alerts even when the app is closed.'}
                    </p>
                  </div>
                </div>
              )}

              {/* ── Feedback sub-view ── */}
              {settingsTab === 'feedback' && (
                <div>
                  <div className="form-group">
                    <label>Rating</label>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      {[1,2,3,4,5].map(s => (
                        <button key={s} onClick={() => setFeedbackForm({ ...feedbackForm, rating: s })} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px' }}>
                          <FiStar size={24} color={s <= feedbackForm.rating ? '#F59E0B' : 'var(--gray)'} fill={s <= feedbackForm.rating ? '#F59E0B' : 'none'} />
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Category</label>
                    <select value={feedbackForm.category} onChange={e => setFeedbackForm({ ...feedbackForm, category: e.target.value })} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', background: 'var(--white)' }}>
                      <option value="general">General</option>
                      <option value="bug">Bug Report</option>
                      <option value="feature">Feature Request</option>
                      <option value="usability">Usability</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Your Message</label>
                    <textarea value={feedbackForm.message} onChange={e => setFeedbackForm({ ...feedbackForm, message: e.target.value })} placeholder="Tell us what you think..." rows={4} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', resize: 'vertical', fontFamily: 'inherit' }} />
                  </div>
                  <button className="btn btn-primary" onClick={submitFeedback}><FiSend size={16} /> Submit Feedback</button>

                  {feedbackList.length > 0 && (
                    <div style={{ marginTop: '24px', borderTop: '1px solid var(--cream-dark)', paddingTop: '20px' }}>
                      <h4 style={{ fontSize: '15px', marginBottom: '12px', color: 'var(--gray)' }}>Your Previous Feedback</h4>
                      {feedbackList.map((fb, i) => (
                        <div key={fb.id || i} style={{ padding: '14px', borderRadius: '10px', background: 'var(--cream)', marginBottom: '10px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                            <div style={{ display: 'flex', gap: '2px' }}>
                              {[1,2,3,4,5].map(s => (
                                <FiStar key={s} size={14} color={s <= fb.rating ? '#F59E0B' : 'var(--gray)'} fill={s <= fb.rating ? '#F59E0B' : 'none'} />
                              ))}
                            </div>
                            <span className="tag" style={{ fontSize: '11px' }}>{fb.category}</span>
                          </div>
                          <p style={{ fontSize: '13px', margin: '0 0 4px', lineHeight: 1.5 }}>{fb.message}</p>
                          <span style={{ fontSize: '11px', color: 'var(--gray)' }}>{fb.created_at ? new Date(fb.created_at).toLocaleDateString('en-ZA') : ''}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* ── Support sub-view ── */}
              {settingsTab === 'support' && (
                <div>
                  <p style={{ fontSize: '14px', color: 'var(--gray)', lineHeight: 1.6, marginBottom: '24px' }}>Need help? Reach out to our team through any of the channels below.</p>
                  <div style={{ display: 'grid', gap: '12px' }}>
                    <a href="mailto:support@grandgatherregistry.co.za" style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '16px 20px', borderRadius: '12px', background: 'var(--cream)', textDecoration: 'none', color: 'var(--dark)', transition: 'all 0.2s' }}>
                      <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(227,66,92,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <FiMail size={18} style={{ color: '#E3425C' }} />
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: '14px' }}>General Support</div>
                        <div style={{ fontSize: '12px', color: 'var(--gray)' }}>support@grandgatherregistry.co.za</div>
                      </div>
                    </a>
                    <a href="mailto:admin@grandgatherregistry.co.za?subject=Account%20Enquiry" style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '16px 20px', borderRadius: '12px', background: 'var(--cream)', textDecoration: 'none', color: 'var(--dark)', transition: 'all 0.2s' }}>
                      <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(59,130,246,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <FiSend size={18} style={{ color: '#3B82F6' }} />
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: '14px' }}>Admin / Account Enquiry</div>
                        <div style={{ fontSize: '12px', color: 'var(--gray)' }}>admin@grandgatherregistry.co.za</div>
                      </div>
                    </a>
                    <a href="https://wa.me/27613911942?text=Hi%2C%20I%20need%20help%20with%20my%20GGR%20account" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '16px 20px', borderRadius: '12px', background: 'var(--cream)', textDecoration: 'none', color: 'var(--dark)', transition: 'all 0.2s' }}>
                      <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(37,211,102,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <FiMessageCircle size={18} style={{ color: '#25D366' }} />
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: '14px' }}>WhatsApp Support</div>
                        <div style={{ fontSize: '12px', color: 'var(--gray)' }}>+27 61 391 1942</div>
                      </div>
                    </a>
                  </div>
                </div>
              )}

              {/* ── Deactivate sub-view ── */}
              {settingsTab === 'danger' && (
                <div>
                  <div style={{ padding: '20px', borderRadius: '12px', border: '2px solid #FCA5A5', background: '#FEF2F2' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '16px' }}>
                      <FiAlertCircle size={24} color="#DC2626" style={{ flexShrink: 0, marginTop: '2px' }} />
                      <div>
                        <h4 style={{ fontSize: '15px', marginBottom: '4px', color: '#DC2626' }}>Deactivate Account</h4>
                        <p style={{ fontSize: '13px', color: '#7F1D1D', lineHeight: 1.5, margin: 0 }}>This action will permanently delete your account. Your data will be archived for reference, but you will need to register again to use the platform.</p>
                      </div>
                    </div>
                    <div className="form-group">
                      <label style={{ color: '#7F1D1D' }}>Confirm Password</label>
                      <input type="password" value={deactivateConfirm.password} onChange={e => setDeactivateConfirm({ ...deactivateConfirm, password: e.target.value })} placeholder="Enter your password to confirm" />
                    </div>
                    <div className="form-group">
                      <label style={{ color: '#7F1D1D' }}>Reason (Optional)</label>
                      <textarea value={deactivateConfirm.reason} onChange={e => setDeactivateConfirm({ ...deactivateConfirm, reason: e.target.value })} placeholder="Why are you leaving?" rows={3} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #FCA5A5', fontSize: '14px', resize: 'vertical', fontFamily: 'inherit' }} />
                    </div>
                    <button className="btn" onClick={deactivateAccount} style={{ background: '#DC2626', color: 'white', border: 'none', display: 'inline-flex', alignItems: 'center', gap: '6px' }}><FiTrash2 size={16} /> Deactivate Account</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}


      {/* Quick Feedback Modal */}
      {showFeedback && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowFeedback(false)}>
          <div className="modal" style={{ maxWidth: '440px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, fontSize: '20px' }}>Share Your Feedback</h2>
              <button onClick={() => setShowFeedback(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><FiX size={20} /></button>
            </div>
            <div className="form-group">
              <label>How would you rate your experience?</label>
              <div style={{ display: 'flex', gap: '8px', padding: '8px 0' }}>
                {[1,2,3,4,5].map(s => (
                  <button key={s} onClick={() => setFeedbackForm({ ...feedbackForm, rating: s })} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', transition: 'transform 0.15s' }}>
                    <FiStar size={32} color={s <= feedbackForm.rating ? '#F59E0B' : 'var(--gray)'} fill={s <= feedbackForm.rating ? '#F59E0B' : 'none'} />
                  </button>
                ))}
              </div>
            </div>
            <div className="form-group">
              <label>Category</label>
              <select value={feedbackForm.category} onChange={e => setFeedbackForm({ ...feedbackForm, category: e.target.value })} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', background: 'var(--white)' }}>
                <option value="general">General</option>
                <option value="bug">Bug Report</option>
                <option value="feature">Feature Request</option>
                <option value="usability">Usability</option>
              </select>
            </div>
            <div className="form-group">
              <label>Your Feedback</label>
              <textarea value={feedbackForm.message} onChange={e => setFeedbackForm({ ...feedbackForm, message: e.target.value })} placeholder="What's on your mind?" rows={4} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', resize: 'vertical', fontFamily: 'inherit' }} />
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button className="btn btn-secondary btn-full" onClick={() => setShowFeedback(false)}>Cancel</button>
              <button className="btn btn-primary btn-full" onClick={submitFeedback}><FiSend size={16} /> Submit</button>
            </div>
          </div>
        </div>
      )}

      {/* GiGi Bot */}
      <GigiBot
        userName={user?.name}
        event={events[0] || null}
        context={{ page: 'dashboard', eventCount: events.length }}
      />

      {/* Balloon celebration overlay — plays on every new event creation */}
      {showCelebration && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 9999,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          background: 'rgba(245,245,245,0.92)',
          animation: 'celebFadeIn 0.4s ease',
          overflow: 'hidden',
          backdropFilter: 'blur(6px)',
        }} onClick={() => setShowCelebration(false)}>
          {/* Beautiful floating balloon animation */}
          <div style={{
            position: 'absolute',
            width: 'min(500px, 90vw)', height: 'min(500px, 90vw)',
            animation: 'balloonRise 4s ease-out forwards',
          }}>
            <video
              autoPlay muted playsInline
              style={{
                width: '100%', height: '100%',
                objectFit: 'contain',
                background: 'transparent',
                mixBlendMode: 'multiply',
              }}
              src="/baloon.mp4"
            />
          </div>
          <div style={{ position: 'relative', zIndex: 2, textAlign: 'center', padding: '0 24px', animation: 'celebScaleIn 0.5s cubic-bezier(0.16,1,0.3,1)', marginTop: '-150px' }}>
            <div style={{ fontSize: '64px', marginBottom: '16px' }}>🎉</div>
            <h2 style={{
              fontFamily: "'DM Serif Display', serif",
              fontSize: 'clamp(26px, 5vw, 50px)',
              color: '#1C1C1E',
              marginBottom: '12px',
            }}>
              Event Created!
            </h2>
            <p style={{
              fontSize: '16px',
              color: 'rgba(0,0,0,0.65)',
              maxWidth: 'min(380px, calc(100vw - 48px))',
              margin: '0 auto',
              lineHeight: 1.7,
              fontWeight: 300,
            }}>
              Your event is live — now add guests, set up your registry, and make it unforgettable!
            </p>
            <div style={{ marginTop: '28px', fontSize: '13px', color: 'rgba(0,0,0,0.4)', letterSpacing: '1px', textTransform: 'uppercase' }}>
              Tap anywhere to continue
            </div>
          </div>
          <style>{`
            @keyframes celebFadeIn { from { opacity: 0; } to { opacity: 1; } }
            @keyframes celebScaleIn { from { opacity: 0; transform: scale(0.85) translateY(20px); } to { opacity: 1; transform: scale(1) translateY(0); } }
            @keyframes balloonRise {
              0% { transform: translateY(60px) scale(0.9); opacity: 0; }
              20% { transform: translateY(0) scale(1); opacity: 1; }
              80% { transform: translateY(-80px) scale(1.05); opacity: 1; }
              100% { transform: translateY(-120px) scale(1.08); opacity: 0; }
            }
          `}</style>
        </div>
      )}
      {/* Vendor Recommendations Modal */}
      {showVendorRecs && recommendedVendors.length > 0 && (
        <>
        <style>{`
          @media (max-width: 640px) {
            .vendor-rec-modal-body {
              border-radius: 20px 20px 0 0 !important;
              max-height: 82vh !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            .vendor-rec-scroll { padding: 20px 18px 8px !important; }
            .vendor-rec-header { padding: 20px 18px 12px !important; }
            .vendor-rec-footer { padding: 10px 18px calc(18px + env(safe-area-inset-bottom, 0px)) !important; }
          }
        `}</style>
        <div style={{
          position: 'fixed', inset: 0, zIndex: 10000,
          display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
          background: 'rgba(0,0,0,0.45)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          animation: 'celebFadeIn 0.35s ease',
        }} onClick={() => { setShowVendorRecs(false); sessionStorage.setItem('vendor_rec_dismissed', '1'); }}>
          <div className="vendor-rec-modal-body" style={{
            background: '#fff',
            borderRadius: '20px',
            maxWidth: '720px',
            width: '100%',
            maxHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 -4px 24px rgba(0,0,0,0.15), 0 20px 60px rgba(0,0,0,0.18)',
            animation: 'celebScaleIn 0.4s cubic-bezier(0.16,1,0.3,1)',
            margin: '0 20px 20px',
          }} onClick={e => e.stopPropagation()}>
            {/* Drag handle (mobile) */}
            <div className="vendor-rec-drag-handle" style={{
              display: 'none',
              width: '36px', height: '4px', borderRadius: '2px',
              background: 'rgba(0,0,0,0.15)',
              margin: '10px auto 0', flexShrink: 0,
            }} />
            <style>{`
              @media (max-width: 640px) {
                .vendor-rec-drag-handle { display: block !important; }
              }
            `}</style>

            {/* Header — sticky */}
            <div className="vendor-rec-header" style={{ flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '28px 28px 0' }}>
              <div>
                <h2 style={{
                  fontFamily: "'DM Serif Display', serif",
                  fontSize: 'clamp(20px, 4vw, 26px)',
                  color: '#1C1C1E',
                  margin: 0,
                }}>
                  Perfect Vendors for Your{' '}
                  <span style={{ color: '#E3425C' }}>{lastCreatedEventType}</span>
                </h2>
                <p style={{
                  fontSize: '13px',
                  color: 'rgba(0,0,0,0.55)',
                  margin: '6px 0 0',
                  fontWeight: 300,
                }}>
                  Top-rated vendors to make your event unforgettable
                </p>
              </div>
              <button
                className="tab-btn"
                onClick={() => { setShowVendorRecs(false); sessionStorage.setItem('vendor_rec_dismissed', '1'); }}
                style={{
                  background: 'rgba(0,0,0,0.06)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '44px', height: '44px', minWidth: '44px', minHeight: '44px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer',
                  fontSize: '22px',
                  color: '#666',
                  flexShrink: 0,
                  marginLeft: '8px',
                }}
                aria-label="Close"
              >
                <FiX />
              </button>
            </div>

            {/* Vendor Cards Grid — scrollable */}
            <div className="vendor-rec-scroll" style={{ overflowY: 'auto', flex: '1 1 auto', padding: '20px 28px 0' }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(145px, 1fr))',
                gap: '14px',
                paddingBottom: '4px',
              }}>
                {recommendedVendors.map(v => {
                  const img = (v.business_gallery && v.business_gallery.length > 0)
                    ? v.business_gallery[0]
                    : (v.avatar || '/default-vendor.png');
                  return (
                    <div key={v.id} style={{
                      background: '#FAFAFA',
                      borderRadius: '14px',
                      overflow: 'hidden',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      cursor: 'pointer',
                    }}
                    className="card"
                    onClick={() => {
                      navigate(`/vendors/${v.id}`);
                      setShowVendorRecs(false);
                    }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                    >
                      {/* Vendor Image */}
                      <div style={{
                        width: '100%', height: '130px',
                        background: `url(${img}) center/cover no-repeat`,
                        backgroundColor: '#E5E5E5',
                      }} />
                      {/* Info */}
                      <div style={{ padding: '12px' }}>
                        <div style={{
                          fontSize: '13px', fontWeight: 600,
                          color: '#1C1C1E',
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        }}>
                          {v.business_name || v.name}
                        </div>
                        <div style={{
                          fontSize: '11px',
                          color: 'rgba(0,0,0,0.5)',
                          marginTop: '2px',
                        }}>
                          {v.business_category}
                        </div>
                        <div style={{
                          display: 'flex', alignItems: 'center', gap: '4px',
                          marginTop: '6px',
                          fontSize: '12px',
                          color: '#E3425C',
                          fontWeight: 500,
                        }}>
                          <FiStar style={{ fill: '#E3425C' }} />
                          {v.avg_rating ? parseFloat(v.avg_rating).toFixed(1) : 'New'}
                          {v.review_count > 0 && (
                            <span style={{ color: 'rgba(0,0,0,0.4)', fontWeight: 300 }}>
                              ({v.review_count})
                            </span>
                          )}
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/vendors/${v.id}`);
                            setShowVendorRecs(false);
                          }}
                          style={{
                            width: '100%',
                            marginTop: '10px',
                            padding: '8px 0',
                            background: '#E3425C',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '12px',
                            fontWeight: 600,
                            cursor: 'pointer',
                          }}
                        >
                          View Profile
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Dismiss button — sticky footer */}
            <div className="vendor-rec-footer" style={{ flexShrink: 0, padding: '14px 28px 20px', borderTop: '1px solid rgba(0,0,0,0.04)' }}>
              <button
                className="btn"
                onClick={() => { setShowVendorRecs(false); sessionStorage.setItem('vendor_rec_dismissed', '1'); }}
                style={{
                  display: 'block', width: '100%',
                  padding: '14px 0',
                  background: 'transparent',
                  color: 'rgba(0,0,0,0.5)',
                  border: '1px solid rgba(0,0,0,0.12)',
                  borderRadius: '14px',
                  fontSize: '15px',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
              >
                Maybe Later
              </button>
            </div>
          </div>
        </div>
        </>
      )}
      {/* Image Cropper Modal */}
      {cropperImage && (
        <ImageCropper
          imageSrc={cropperImage.src}
          aspect={cropperImage.aspect}
          title={cropperImage.title}
          onCancel={() => setCropperImage(null)}
          onCropDone={(croppedBlob) => {
            const file = new File([croppedBlob], 'cropped-cover.jpg', { type: 'image/jpeg' });
            setNewEvent(prev => ({ ...prev, coverFile: file }));
            setCropperImage(null);
          }}
        />
      )}
    </div>
  );
}
